/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-disable @typescript-eslint/no-explicit-any */
//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import { Schemas } from './types';

export interface RequestBody$AdminAuthController_login {
  'application/json': Schemas.AdminLoginDto;
}
export interface Response$AdminAuthController_login$Status$200 {
  'application/json': Schemas.AdminUserJwtResponseDto;
}
export interface Parameter$AdminUserController_getUsers {
  includeBlocked?: boolean;
}
export interface Response$AdminUserController_getUsers$Status$200 {
  'application/json': Schemas.User[];
}
export interface Parameter$AdminUserController_updateCurrentUser {
  id: string;
}
export interface RequestBody$AdminUserController_updateCurrentUser {
  'application/json': Schemas.AdminUpdateUserDto;
}
export interface Response$AdminUserController_updateCurrentUser$Status$200 {
  'application/json': Schemas.User;
}
export interface Parameter$AdminUserController_blockUser {
  id: string;
}
export interface RequestBody$AdminUserController_blockUser {
  'application/json': Schemas.AdminBlockUserDto;
}
export interface Response$AdminUserController_blockUser$Status$200 {
  'application/json': Schemas.User;
}
export interface Parameter$AdminUserController_unblockUser {
  id: string;
}
export interface Response$AdminUserController_unblockUser$Status$200 {
  'application/json': Schemas.User;
}
export interface Response$AdminUserController_getCurrentUser$Status$200 {
  'application/json': Schemas.User;
}
export interface Parameter$AdminCompanyController_findAll {
  page?: number;
  perPage?: number;
  term?: string;
  status?: string;
  countryCode?: string;
}
export interface Response$AdminCompanyController_findAll$Status$200 {
  'application/json': Schemas.PaginatedAdminCompaniesResponseDto;
}
export interface Response$AdminCompanyController_getAllPromoCodes$Status$200 {
  'application/json': Schemas.AdminPromoCodeDto[];
}
export interface Parameter$AdminCompanyController_listMemberships {
  page?: number;
  perPage?: number;
  companyId?: string;
  userId?: string;
  role?: 'admin' | 'accountant' | 'kyc' | 'support';
  term?: string;
}
export interface Response$AdminCompanyController_listMemberships$Status$200 {
  'application/json': Schemas.PaginatedAdminMembershipsResponseDto;
}
export interface Parameter$AdminCompanyController_findOneById {
  id: string;
}
export interface Response$AdminCompanyController_findOneById$Status$200 {
  'application/json': Schemas.AdminCompanyResponseDto;
}
export interface Parameter$AdminCompanyController_updateOneById {
  id: string;
}
export interface RequestBody$AdminCompanyController_updateOneById {
  'application/json': Schemas.AdminCompanyUpdateDto;
}
export interface Response$AdminCompanyController_updateOneById$Status$200 {
  'application/json': Schemas.AdminCompanyResponseDto;
}
export interface Parameter$AdminCompanyController_addUser {
  id: string;
}
export interface RequestBody$AdminCompanyController_addUser {
  'application/json': Schemas.AdminCompanyUserAddDto;
}
export interface Response$AdminCompanyController_addUser$Status$201 {
  'application/json': Schemas.AdminCompanyUserResponseDto;
}
export interface Parameter$AdminCompanyController_removeUser {
  id: string;
  userId: string;
}
export interface Response$AdminCompanyController_removeUser$Status$200 {
  'application/json': Schemas.AdminCompanyUserResponseDto;
}
export interface Parameter$AdminObligationFileController_create {
  companyId: string;
}
export interface RequestBody$AdminObligationFileController_create {
  'multipart/form-data': Schemas.AdminCreateObligationFileDto;
}
export interface Response$AdminObligationFileController_create$Status$201 {
  'application/json': Schemas.AdminObligationFileResponseDto;
}
export interface Parameter$AdminObligationFileController_delete {
  companyId: string;
  id: string;
}
export interface Response$AdminObligationFileController_delete$Status$200 {
  'application/json': boolean;
}
export interface Parameter$AdminObligationFileController_updateOneById {
  companyId: string;
  id: string;
}
export interface RequestBody$AdminObligationFileController_updateOneById {
  'application/json': Schemas.AdminUpdateObligationFileDto;
}
export interface Response$AdminObligationFileController_updateOneById$Status$200 {
  'application/json': Schemas.AdminObligationFileResponseDto;
}
export interface Parameter$AdminTransactionController_findAll {
  companyId: string;
  page?: number;
  dateFrom?: string;
  dateTo?: string;
  term?: string;
  accountId?: string;
  adminStatus?:
    | 'ready'
    | 'processing'
    | 'paused'
    | 'requested_changes'
    | 'processed';
}
export interface Response$AdminTransactionController_findAll$Status$200 {
  'application/json': Schemas.PaginatedTransactionResponseDto;
}
export interface Parameter$AdminTransactionController_toExcel {
  companyId: string;
  page?: number;
  dateFrom?: string;
  dateTo?: string;
  term?: string;
  accountId?: string;
  adminStatus?:
    | 'ready'
    | 'processing'
    | 'paused'
    | 'requested_changes'
    | 'processed';
}
export interface Response$AdminTransactionController_toExcel$Status$200 {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': string;
}
export interface Parameter$AdminTransactionController_findOneById {
  companyId: string;
  id: string;
}
export interface Response$AdminTransactionController_findOneById$Status$200 {
  'application/json': Schemas.Transaction;
}
export interface Parameter$AdminTransactionController_updateOneById {
  companyId: string;
  id: string;
}
export interface RequestBody$AdminTransactionController_updateOneById {
  'application/json': Schemas.AdminUpdateTransactionDto;
}
export interface Response$AdminTransactionController_updateOneById$Status$200 {
  'application/json': Schemas.Transaction;
}
export interface Parameter$AdminTransactionIngestController_findAll {
  companyId: string;
  /** Include batches that have no transactions in the database. Off by default: the GoCardless sync creates a batch on every poll, and the vast majority of those import nothing. Failed batches are returned either way — hiding them would defeat the point of recording them. */
  includeEmpty?: boolean;
}
export interface Response$AdminTransactionIngestController_findAll$Status$200 {
  'application/json': Schemas.AdminTransactionIngestDto[];
}
export interface Parameter$AdminTransactionIngestController_findRows {
  companyId: string;
  id: string;
}
export interface Response$AdminTransactionIngestController_findRows$Status$200 {
  'application/json': Schemas.AdminTransactionIngestRowDto[];
}
export interface Parameter$AdminDocumentController_findAll {
  companyId: string;
  perPage?: number;
  page?: number;
  type?: string;
  term?: string;
  /** Filter by document name (substring, case-insensitive) */
  name?: string;
  /** Filter by linked contact name (substring, case-insensitive) */
  contactName?: string;
  /** Filter by Bob50 reference id (substring, case-insensitive) */
  referenceId?: string;
  /** Filter by invoice number (substring, case-insensitive) */
  invoiceNumber?: string;
  adminStatus?:
    | 'ready'
    | 'processing'
    | 'paused'
    | 'requested_changes'
    | 'processed';
  dateFrom?: string;
  dateTo?: string;
  filterDateBy?: 'createdAt' | 'issueDate';
  sortBy?: 'createdAt' | 'status';
  status?: 'processed' | 'processing' | 'ready' | 'error';
  ignoreDrafts?: boolean;
  /** Only documents carrying an error. A facet, not a status: it combines with `status` rather than replacing it, so a flagged document still answers its own status bucket. `status=error` is a deprecated alias for this flag. */
  withErrors?: boolean;
  blankIssueDate?: boolean;
}
export interface Response$AdminDocumentController_findAll$Status$200 {
  'application/json': Schemas.PaginatedDocumentResponse;
}
export interface Parameter$AdminDocumentController_bulkDownload {
  companyId: string;
  perPage?: number;
  page?: number;
  type?: string;
  term?: string;
  /** Filter by document name (substring, case-insensitive) */
  name?: string;
  /** Filter by linked contact name (substring, case-insensitive) */
  contactName?: string;
  /** Filter by Bob50 reference id (substring, case-insensitive) */
  referenceId?: string;
  /** Filter by invoice number (substring, case-insensitive) */
  invoiceNumber?: string;
  adminStatus?:
    | 'ready'
    | 'processing'
    | 'paused'
    | 'requested_changes'
    | 'processed';
  dateFrom?: string;
  dateTo?: string;
  filterDateBy?: 'createdAt' | 'issueDate';
  sortBy?: 'createdAt' | 'status';
  status?: 'processed' | 'processing' | 'ready' | 'error';
  ignoreDrafts?: boolean;
  /** Only documents carrying an error. A facet, not a status: it combines with `status` rather than replacing it, so a flagged document still answers its own status bucket. `status=error` is a deprecated alias for this flag. */
  withErrors?: boolean;
  blankIssueDate?: boolean;
}
export interface Parameter$AdminDocumentController_findLastParamsForContact {
  companyId: string;
  contactId: string;
}
export interface Response$AdminDocumentController_findLastParamsForContact$Status$200 {
  'application/json': Schemas.BobLastDataForContactResponseDto;
}
export interface Parameter$AdminDocumentController_findOneById {
  companyId: string;
  id: string;
}
export interface Response$AdminDocumentController_findOneById$Status$200 {
  'application/json': Schemas.Document;
}
export interface Parameter$AdminDocumentController_updateOneById {
  companyId: string;
  id: string;
}
export interface RequestBody$AdminDocumentController_updateOneById {
  'application/json': Schemas.AdminUpdateDocumentDto;
}
export interface Response$AdminDocumentController_updateOneById$Status$200 {
  'application/json': Schemas.Document;
}
export interface Parameter$AdminDocumentController_bulkUpdate {
  companyId: string;
}
export interface RequestBody$AdminDocumentController_bulkUpdate {
  'application/json': Schemas.AdminBulkUpdateDocumentDto;
}
export interface Parameter$AdminDocumentController_retryBobSync {
  companyId: string;
  id: string;
}
export interface Response$AdminDocumentController_retryBobSync$Status$200 {
  'application/json': Schemas.Document;
}
export interface Response$AdminDocumentController_retryBobSync$Status$400 {
  'application/json': Schemas.AdminDocumentBadRequestResponseDto;
}
export interface Response$AdminDocumentController_retryBobSync$Status$409 {
  'application/json': Schemas.BobRetryConflictResponseDto;
}
export interface Parameter$AdminDocumentController_runRecognition {
  companyId: string;
  id: string;
}
export interface Parameter$AdminAccountsController_getAccounts {
  companyId: string;
}
export interface Response$AdminAccountsController_getAccounts$Status$200 {
  'application/json': Schemas.Account[];
}
export interface Parameter$AdminAccountsController_syncConnection {
  companyId: string;
  id: string;
}
export interface Parameter$AdminBalancePortfolioController_findDiscrepancies {
  windowDays?: number;
}
export interface Response$AdminBalancePortfolioController_findDiscrepancies$Status$200 {
  'application/json': Schemas.BalancePortfolioResponseDto;
}
export interface Parameter$AdminAccountingUsageController_list {
  /** Calendar year; defaults to the current one */
  year?: number;
}
export interface Response$AdminAccountingUsageController_list$Status$200 {
  'application/json': Schemas.AdminAccountingUsageListDto;
}
export interface Parameter$AdminAccountingUsageController_getPlan {
  companyId: string;
}
export interface Response$AdminAccountingUsageController_getPlan$Status$200 {
  'application/json': Schemas.AdminAccountingPlanDto;
}
export interface Parameter$AdminAccountingUsageController_updatePlan {
  companyId: string;
}
export interface RequestBody$AdminAccountingUsageController_updatePlan {
  'application/json': Schemas.AdminAccountingPlanUpdateDto;
}
export interface Response$AdminAccountingUsageController_updatePlan$Status$200 {
  'application/json': Schemas.AdminAccountingPlanDto;
}
export interface Parameter$AdminMdsIncorporationsController_list {
  /** Page number, 40 rows per page — of MDS's queue, or of the provisioned view's own result */
  page?: number;
  /** MDS full-text search over legal name, trade name, RCS, VAT and tax id. In the provisioned view it narrows differently: that list is paged from legacy, so the term matches the legacy company name only — an RCS number finds nothing there. */
  search?: string;
  /** Provisioned companies whose Master Data record changed since the last fill */
  provisioned?: boolean;
  /** Provisioned view only: false lists every provisioned company, not only the changed ones */
  changedOnly?: boolean;
}
export interface Response$AdminMdsIncorporationsController_list$Status$200 {
  'application/json': Schemas.MdsIncorporationListDto;
}
export interface Parameter$AdminMdsIncorporationsController_details {
  mdsCompanyId: string;
}
export interface Response$AdminMdsIncorporationsController_details$Status$200 {
  'application/json': Schemas.MdsIncorporationDetailsDto;
}
export interface Parameter$AdminMdsIncorporationsController_provision {
  mdsCompanyId: string;
}
export interface RequestBody$AdminMdsIncorporationsController_provision {
  'application/json': Schemas.ProvisionIncorporationDto;
}
export interface Response$AdminMdsIncorporationsController_provision$Status$201 {
  'application/json': Schemas.ProvisionIncorporationResultDto;
}
export interface Parameter$AdminMdsIncorporationsController_syncMdsStatus {
  mdsCompanyId: string;
}
export interface RequestBody$AdminMdsIncorporationsController_syncMdsStatus {
  'application/json': Schemas.ProvisionIncorporationDto;
}
export interface Response$AdminMdsIncorporationsController_syncMdsStatus$Status$201 {
  'application/json': Schemas.SyncMdsStatusResultDto;
}
export interface Parameter$AdminMdsIncorporationsController_refreshFromMds {
  mdsCompanyId: string;
}
export interface RequestBody$AdminMdsIncorporationsController_refreshFromMds {
  'application/json': Schemas.RefreshFromMdsDto;
}
export interface Response$AdminMdsIncorporationsController_refreshFromMds$Status$201 {
  'application/json': Schemas.RefreshFromMdsResultDto;
}
export interface Parameter$AdminEventController_findAll {
  companyId: string;
  entityType:
    | 'category'
    | 'company'
    | 'contact'
    | 'file'
    | 'transaction'
    | 'project'
    | 'company_file'
    | 'incorporation_kyc'
    | 'obligation'
    | 'obligation_file'
    | 'company_user'
    | 'user'
    | 'accounting_plan';
  entityId: string;
}
export interface Response$AdminEventController_findAll$Status$200 {
  'application/json': Schemas.Event[];
}
export interface Parameter$AdminEventController_findMembershipJournal {
  companyId: string;
  page?: number;
  perPage?: number;
  /** Target member (optional) */
  entityId?: string;
  type?:
    | 'created'
    | 'updated'
    | 'deleted'
    | 'file_uploaded'
    | 'approved'
    | 'requested_changes';
  dateFrom?: string;
  dateTo?: string;
}
export interface Response$AdminEventController_findMembershipJournal$Status$200 {
  'application/json': Schemas.PaginatedMembershipEventsResponseDto;
}
export interface Parameter$AdminExportController_describeCompany {
  companyId: string;
}
export interface Response$AdminExportController_describeCompany$Status$200 {
  'application/json': Schemas.ExportCompanyDto;
}
export interface Parameter$AdminExportController_listContacts {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  /** Include raw, the verbatim ac_compan row behind each contact. Off by default because it is by far the largest field on the record — ask for it with a smaller limit than you would use otherwise. */
  includeRawBobData?: boolean;
  companyId: string;
}
export interface Response$AdminExportController_listContacts$Status$200 {
  'application/json': Schemas.ExportContactsPageDto;
}
export interface Parameter$AdminExportController_listBobAccounts {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  companyId: string;
}
export interface Response$AdminExportController_listBobAccounts$Status$200 {
  'application/json': Schemas.ExportBobAccountsPageDto;
}
export interface Parameter$AdminExportController_listBobDaybooks {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  companyId: string;
}
export interface Response$AdminExportController_listBobDaybooks$Status$200 {
  'application/json': Schemas.ExportBobDaybooksPageDto;
}
export interface Parameter$AdminExportController_listAccounts {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  companyId: string;
}
export interface Response$AdminExportController_listAccounts$Status$200 {
  'application/json': Schemas.ExportAccountsPageDto;
}
export interface Parameter$AdminExportController_listDocuments {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  /** Lifetime of downloadUrl in seconds, 60..604800 (7 days, the AWS ceiling). Ask for a window that covers the whole download; an expired URL means re-requesting the page. */
  urlExpiresIn?: number;
  /** Include recognitionData, the raw OCR prediction. Off by default because it is by far the largest field on the record — ask for it with a smaller limit than you would use otherwise. */
  includeRecognitionData?: boolean;
  companyId: string;
}
export interface Response$AdminExportController_listDocuments$Status$200 {
  'application/json': Schemas.ExportDocumentsPageDto;
}
export interface Parameter$AdminExportController_listBillingDocuments {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  /** Lifetime of downloadUrl in seconds, 60..604800 (7 days, the AWS ceiling). Ask for a window that covers the whole download; an expired URL means re-requesting the page. */
  urlExpiresIn?: number;
  companyId: string;
}
export interface Response$AdminExportController_listBillingDocuments$Status$200 {
  'application/json': Schemas.ExportBillingDocumentsPageDto;
}
export interface Parameter$AdminExportController_listTransactionIngests {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  /** Lifetime of downloadUrl in seconds, 60..604800 (7 days, the AWS ceiling). Ask for a window that covers the whole download; an expired URL means re-requesting the page. */
  urlExpiresIn?: number;
  companyId: string;
}
export interface Response$AdminExportController_listTransactionIngests$Status$200 {
  'application/json': Schemas.ExportTransactionIngestsPageDto;
}
export interface Parameter$AdminExportController_listTransactions {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  companyId: string;
}
export interface Response$AdminExportController_listTransactions$Status$200 {
  'application/json': Schemas.ExportTransactionsPageDto;
}
export interface Parameter$AdminExportController_listTransactionDocuments {
  /** Opaque cursor taken from the previous page's nextCursor. Omit it to start from the beginning. */
  cursor?: string;
  /** Rows per page, 1..1000. */
  limit?: number;
  companyId: string;
}
export interface Response$AdminExportController_listTransactionDocuments$Status$200 {
  'application/json': Schemas.ExportTransactionDocumentsPageDto;
}
export interface Parameter$AdminIncorporationController_findOneById {
  companyId: string;
}
export interface Response$AdminIncorporationController_findOneById$Status$200 {
  'application/json': Schemas.Incorporation;
}
export interface Parameter$AdminIncorporationController_updateOneById {
  companyId: string;
}
export interface RequestBody$AdminIncorporationController_updateOneById {
  'application/json': Schemas.AdminIncorporationDto;
}
export interface Response$AdminIncorporationController_updateOneById$Status$200 {
  'application/json': Schemas.Incorporation;
}
export interface Parameter$AdminIncorporationController_approveKyc {
  companyId: string;
}
export interface Response$AdminIncorporationController_approveKyc$Status$200 {
  'application/json': Schemas.Incorporation;
}
export interface Parameter$AdminIncorporationController_failKyc {
  companyId: string;
}
export interface Response$AdminIncorporationController_failKyc$Status$200 {
  'application/json': Schemas.Incorporation;
}
export interface Parameter$AdminCompanyFileController_findAll {
  companyId: string;
  type: string;
  personId: string;
}
export interface Response$AdminCompanyFileController_findAll$Status$200 {
  'application/json': Schemas.CompanyFile[];
}
export interface Parameter$AdminCompanyFileController_create {
  companyId: string;
}
export interface RequestBody$AdminCompanyFileController_create {
  'multipart/form-data': Schemas.AdminCreateCompanyFileDto;
}
export interface Response$AdminCompanyFileController_create$Status$201 {
  'application/json': Schemas.CompanyFile;
}
export interface Parameter$AdminCompanyFileController_createFromTaskFile {
  companyId: string;
}
export interface RequestBody$AdminCompanyFileController_createFromTaskFile {
  'application/json': Schemas.AdminCreateCompanyFileFromTaskFileDto;
}
export interface Response$AdminCompanyFileController_createFromTaskFile$Status$201 {
  'application/json': Schemas.CompanyFile;
}
export interface Parameter$AdminCompanyFileController_delete {
  companyId: string;
  id: string;
}
export interface Response$AdminCompanyFileController_delete$Status$200 {
  'application/json': Schemas.CompanyFile;
}
export interface Parameter$AdminCompanyFileController_updateOneById {
  companyId: string;
  id: string;
}
export interface RequestBody$AdminCompanyFileController_updateOneById {
  'multipart/form-data': Schemas.AdminUpdateCompanyFileDto;
}
export interface Response$AdminCompanyFileController_updateOneById$Status$200 {
  'application/json': Schemas.CompanyFile;
}
export interface Parameter$AdminOnfidoDataController_create {
  personId: string;
  companyId: string;
}
export interface Response$AdminOnfidoDataController_create$Status$200 {
  'application/json': Schemas.OnfidoData[];
}
export interface Parameter$AdminOnfidoDataController_generateLink {
  personId: string;
  companyId: string;
}
export interface Response$AdminOnfidoDataController_generateLink$Status$200 {
  'application/json': Schemas.OnfidoData;
}
export interface Response$AdminOnfidoDataController_generateLink$Status$201 {
  'application/json': Schemas.OnfidoData;
}
export interface Parameter$AdminSumsubDataController_findForPerson {
  personId: string;
  companyId: string;
}
export interface Response$AdminSumsubDataController_findForPerson$Status$200 {
  'application/json': Schemas.SumsubData | null;
}
export interface Parameter$AdminSumsubDataController_generateLink {
  personId: string;
  companyId: string;
}
export interface Response$AdminSumsubDataController_generateLink$Status$200 {
  'application/json': Schemas.SumsubData;
}
export interface Response$AdminSumsubDataController_generateLink$Status$201 {
  'application/json': Schemas.SumsubData;
}
export interface Parameter$AdminTaskController_findAll {
  topic?: string;
  companyId?: string;
  onlyForUser?: boolean;
}
export interface Response$AdminTaskController_findAll$Status$200 {
  'application/json': Schemas.Task[];
}
export interface RequestBody$AdminTaskController_create {
  'application/json': Schemas.AdminTaskDto;
}
export interface Response$AdminTaskController_create$Status$201 {
  'application/json': Schemas.Task;
}
export interface RequestBody$AdminTaskController_createV2 {
  'application/json': Schemas.AdminCreateTaskV2Dto;
}
export interface Response$AdminTaskController_createV2$Status$201 {
  'application/json': Schemas.Task;
}
export interface Parameter$AdminTaskController_updateOneById {
  id: string;
}
export interface RequestBody$AdminTaskController_updateOneById {
  'application/json': Schemas.AdminTaskUpdateDto;
}
export interface Response$AdminTaskController_updateOneById$Status$200 {
  'application/json': Schemas.Task;
}
export interface Parameter$AdminTaskController_close {
  id: string;
}
export interface Response$AdminTaskController_close$Status$200 {
  'application/json': Schemas.Task;
}
export interface Parameter$AdminTaskFileController_create {
  companyId: string;
}
export interface RequestBody$AdminTaskFileController_create {
  'multipart/form-data': Schemas.AdminCreateTaskFileDto;
}
export interface Response$AdminTaskFileController_create$Status$201 {
  'application/json': Schemas.TaskFile;
}
export interface Response$AdminBillingPeriodController_findAllUnapproved$Status$200 {
  'application/json': Schemas.BillingPeriodSummaryResponseDto[];
}
export interface Parameter$AdminBillingPeriodController_findAll {
  companyId: string;
}
export interface Response$AdminBillingPeriodController_findAll$Status$200 {
  'application/json': Schemas.BillingPeriod[];
}
export interface Parameter$AdminBillingPeriodController_create {
  companyId: string;
}
export interface RequestBody$AdminBillingPeriodController_create {
  'application/json': Schemas.AdminBillingPeriodDto;
}
export interface Response$AdminBillingPeriodController_create$Status$201 {
  'application/json': Schemas.BillingPeriod;
}
export interface Parameter$AdminBillingPeriodController_findOneById {
  id: string;
  companyId: string;
}
export interface Response$AdminBillingPeriodController_findOneById$Status$200 {
  'application/json': Schemas.BillingPeriod;
}
export interface Parameter$AdminBillingPeriodController_delete {
  id: string;
  companyId: string;
}
export interface Response$AdminBillingPeriodController_delete$Status$200 {
  'application/json': Schemas.BillingPeriod;
}
export interface Parameter$AdminBillingPeriodController_updateOneById {
  id: string;
  companyId: string;
}
export interface RequestBody$AdminBillingPeriodController_updateOneById {
  'application/json': Schemas.AdminBillingPeriodDto;
}
export interface Response$AdminBillingPeriodController_updateOneById$Status$200 {
  'application/json': Schemas.BillingPeriod;
}
export interface Parameter$AdminBillingPeriodController_approve {
  id: string;
  companyId: string;
}
export interface Response$AdminBillingPeriodController_approve$Status$200 {
  'application/json': Schemas.BillingPeriod;
}
export interface Parameter$AdminBobAccountController_findAll {
  companyId: string;
  page?: number;
  term?: string;
}
export interface Response$AdminBobAccountController_findAll$Status$200 {
  'application/json': Schemas.BobAccount[];
}
export interface Parameter$AdminBobDaybookController_findAll {
  companyId: string;
}
export interface Response$AdminBobDaybookController_findAll$Status$200 {
  'application/json': Schemas.BobDaybook[];
}
export interface Parameter$AdminBobVATController_findAll {
  companyId: string;
}
export interface Response$AdminBobVATController_findAll$Status$200 {
  'application/json': Schemas.BobVAT[];
}
export interface Parameter$AdminBobContactController_findAll {
  companyId: string;
  page?: number;
  term?: string;
}
export interface Response$AdminBobContactController_findAll$Status$200 {
  'application/json': Schemas.BobContact[];
}
export interface Parameter$AdminBobContactController_create {
  companyId: string;
}
export interface RequestBody$AdminBobContactController_create {
  'application/json': Schemas.AdminBobContactDto;
}
export interface Response$AdminBobContactController_create$Status$201 {
  'application/json': Schemas.BobContact;
}
export interface Response$AdminBobContactController_create$Status$409 {
  'application/json': Schemas.AdminBobContactConflictDto;
}
export interface Parameter$AdminBobContactController_suggestBobId {
  companyId: string;
  /** Contact name to pack into a reference */
  name: string;
}
export interface Response$AdminBobContactController_suggestBobId$Status$200 {
  'application/json': Schemas.AdminSuggestedBobIdDto;
}
export interface Parameter$AdminProcessTemplateController_findAll {
  perPage?: number;
  page?: number;
  term?: string;
  isPublished?: boolean;
  stepId?: string;
}
export interface Response$AdminProcessTemplateController_findAll$Status$200 {
  'application/json': Schemas.PaginatedProcessTemplateResponse;
}
export interface RequestBody$AdminProcessTemplateController_create {
  'application/json': Schemas.ProcessTemplateRequestDto;
}
export interface Response$AdminProcessTemplateController_create$Status$201 {
  'application/json': Schemas.ProcessTemplateResponseDto;
}
export interface Parameter$AdminProcessTemplateController_findOneById {
  id: string;
}
export interface Response$AdminProcessTemplateController_findOneById$Status$200 {
  'application/json': Schemas.ProcessTemplateResponseDto;
}
export interface Parameter$AdminProcessTemplateController_delete {
  id: string;
}
export interface Parameter$AdminProcessTemplateController_update {
  id: string;
}
export interface RequestBody$AdminProcessTemplateController_update {
  'application/json': Schemas.ProcessTemplateRequestDto;
}
export interface Response$AdminProcessTemplateController_update$Status$200 {
  'application/json': Schemas.ProcessTemplateResponseDto;
}
export interface Parameter$AdminProcessTemplateController_publish {
  id: string;
}
export interface Parameter$AdminProcessTemplateController_unpublish {
  id: string;
}
export interface Parameter$AdminStepController_findAll {
  term?: string;
}
export interface Response$AdminStepController_findAll$Status$200 {
  'application/json': Schemas.StepResponseDto[];
}
export interface RequestBody$AdminStepController_create {
  'application/json': Schemas.StepRequestDto;
}
export interface Response$AdminStepController_create$Status$201 {
  'application/json': Schemas.StepResponseDto;
}
export interface Response$AdminStepController_create$Status$400 {
  'application/json': Schemas.StepErrorResponseDto;
}
export interface Parameter$AdminStepController_delete {
  id: string;
}
export interface Parameter$AdminStepController_update {
  id: string;
}
export interface RequestBody$AdminStepController_update {
  'application/json': Schemas.StepRequestDto;
}
export interface Response$AdminStepController_update$Status$200 {
  'application/json': Schemas.StepResponseDto;
}
export interface Parameter$AdminPayslipDocumentController_findAll {
  companyId: string;
  page?: number;
  perPage?: number;
  term?: string;
}
export interface Response$AdminPayslipDocumentController_findAll$Status$200 {
  'application/json': Schemas.PaginatedPayslipDocumentResponse;
}
export interface Parameter$AdminPayslipDocumentController_create {
  companyId: string;
}
export interface RequestBody$AdminPayslipDocumentController_create {
  'multipart/form-data': Schemas.AdminCreatePayslipDocumentDto;
}
export interface Parameter$AdminPayslipDocumentController_findOneById {
  companyId: string;
  id: string;
}
export interface Response$AdminPayslipDocumentController_findOneById$Status$200 {
  'application/json': Schemas.PayslipDocument;
}
export interface Parameter$AdminPayslipDocumentController_delete {
  companyId: string;
  id: string;
}
export interface Response$AdminPayslipDocumentController_delete$Status$200 {
  'application/json': Schemas.PayslipDocument;
}
export interface Parameter$AdminPayslipDocumentController_updateOneById {
  companyId: string;
  id: string;
}
export interface RequestBody$AdminPayslipDocumentController_updateOneById {
  'multipart/form-data': Schemas.AdminUpdatePayslipDocumentDto;
}
export interface Parameter$AdminBillingDocumentController_findAllOneTimeInvoices {
  companyId: string;
}
export interface Response$AdminBillingDocumentController_findAllOneTimeInvoices$Status$200 {
  'application/json': Schemas.BillingDocument[];
}
export interface Parameter$AdminBillingDocumentController_createOneTimeInvoice {
  companyId: string;
}
export interface RequestBody$AdminBillingDocumentController_createOneTimeInvoice {
  'application/json': Schemas.AdminCreateOneTimeBillingInvoiceDto;
}
export interface Response$AdminBillingDocumentController_createOneTimeInvoice$Status$201 {
  'application/json': Schemas.BillingDocument;
}
export interface Parameter$AdminBillingDocumentController_createCreditNote {
  companyId: string;
}
export interface RequestBody$AdminBillingDocumentController_createCreditNote {
  'application/json': Schemas.AdminCreateCreditNoteDto;
}
export interface Parameter$AdminBillingDocumentController_createCreditNoteV3 {
  companyId: string;
}
export interface RequestBody$AdminBillingDocumentController_createCreditNoteV3 {
  'application/json': Schemas.AdminCreateCreditNoteV3Dto;
}
export interface Response$AdminBillingDocumentController_createCreditNoteV3$Status$201 {
  'application/json': Schemas.BillingDocument;
}
export interface Parameter$AdminBillingDocumentController_getCreditNoteCapabilities {
  companyId: string;
}
export interface Response$AdminBillingDocumentController_getCreditNoteCapabilities$Status$200 {
  'application/json': Schemas.AdminCreditNoteCapabilitiesDto;
}
export interface Parameter$AdminBillingDocumentController_findOneById {
  companyId: string;
  id: string;
}
export interface Response$AdminBillingDocumentController_findOneById$Status$200 {
  'application/json': Schemas.BillingDocument;
}
export interface Parameter$AdminBillingDocumentController_delete {
  companyId: string;
  id: string;
}
export interface Response$AdminBillingDocumentController_delete$Status$200 {
  'application/json': Schemas.BillingDocument;
}
export interface Parameter$AdminBillingDocumentController_updateOneById {
  companyId: string;
  id: string;
}
export interface RequestBody$AdminBillingDocumentController_updateOneById {
  'application/json': Schemas.AdminUpdateBillingDocumentDto;
}
export interface Response$AdminBillingDocumentController_updateOneById$Status$200 {
  'application/json': Schemas.BillingDocument;
}
export interface Parameter$AdminBillingDocumentController_create {
  companyId: string;
}
export interface RequestBody$AdminBillingDocumentController_create {
  'multipart/form-data': Schemas.AdminCreateBillingDocumentDto;
}
export interface Response$AdminBillingDocumentController_create$Status$201 {
  'application/json': Schemas.BillingDocument;
}
export interface Parameter$AdminCurrencyExchangeRateController_getRate {
  from: string;
  to: string;
  date: string;
}
export interface Response$AdminCurrencyExchangeRateController_getRate$Status$200 {
  'application/json': Schemas.RateResponse;
}
export interface Parameter$AdminPersonsController_findAll {
  companyId: string;
}
export interface Response$AdminPersonsController_findAll$Status$200 {
  'application/json': Schemas.PersonResponseDto[];
}
export interface Parameter$AdminPersonsController_create {
  companyId: string;
}
export interface RequestBody$AdminPersonsController_create {
  'application/json': Schemas.CreatePersonDto;
}
export interface Response$AdminPersonsController_create$Status$201 {
  'application/json': Schemas.PersonResponseDto;
}
export interface Parameter$AdminPersonsController_findOne {
  companyId: string;
  id: string;
}
export interface Response$AdminPersonsController_findOne$Status$200 {
  'application/json': Schemas.PersonResponseDto;
}
export interface Parameter$AdminPersonsController_update {
  companyId: string;
  id: string;
}
export interface RequestBody$AdminPersonsController_update {
  'application/json': Schemas.UpdatePersonDto;
}
export interface Response$AdminPersonsController_update$Status$200 {
  'application/json': Schemas.PersonResponseDto;
}
export interface Parameter$AdminPersonsController_remove {
  companyId: string;
  id: string;
}
export interface Parameter$AdminPersonsController_assignUboNumber {
  companyId: string;
  id: string;
}
export interface Parameter$AdminObligationController_findAll {
  companyId: string;
}
export interface Response$AdminObligationController_findAll$Status$200 {
  'application/json': Schemas.AdminObligationResponseDto[];
}
export interface Parameter$AdminObligationController_create {
  companyId: string;
}
export interface RequestBody$AdminObligationController_create {
  'application/json': Schemas.AdminCreateObligationDto;
}
export interface Response$AdminObligationController_create$Status$201 {
  'application/json': Schemas.AdminObligationResponseDto;
}
export interface Parameter$AdminObligationController_findOneById {
  companyId: string;
  id: string;
}
export interface Response$AdminObligationController_findOneById$Status$200 {
  'application/json': Schemas.AdminObligationResponseDto;
}
export interface Parameter$AdminObligationController_deleteOneById {
  companyId: string;
  id: string;
}
export interface Response$AdminObligationController_deleteOneById$Status$200 {
  'application/json': boolean;
}
export interface Parameter$AdminObligationController_updateOneById {
  companyId: string;
  id: string;
}
export interface RequestBody$AdminObligationController_updateOneById {
  'application/json': Schemas.AdminUpdateObligationDto;
}
export interface Response$AdminObligationController_updateOneById$Status$200 {
  'application/json': Schemas.AdminObligationResponseDto;
}
export interface Parameter$AdminObligationController_findEventsById {
  companyId: string;
  id: string;
}
export interface Response$AdminObligationController_findEventsById$Status$200 {
  'application/json': Schemas.Event[];
}
export interface Parameter$NewsletterController_getRecipients {
  /** Which audience to draw recipients from. `in_service` (default): every member of an in-service company, no marketing-consent filter — "Product updates" is a service announcement, not a campaign. `opted_in`: the same pool narrowed to members with is_opted_in_to_marketing = true. A confirmed email is required either way. */
  audience?: Schemas.NewsletterAudience;
}
export interface Response$NewsletterController_getRecipients$Status$200 {
  'application/json': Schemas.RecipientCompanyDto[];
}
export interface RequestBody$NewsletterController_sync {
  'application/json': Schemas.SyncRequestDto;
}
export interface Response$NewsletterController_sync$Status$201 {
  'application/json': Schemas.SyncAcceptedDto;
}
export interface Response$NewsletterController_sync$Status$409 {
  'application/json': Schemas.SyncConflictDto;
}
export interface Parameter$NewsletterController_syncStatus {
  jobId: string;
}
export interface Response$NewsletterController_syncStatus$Status$200 {
  'application/json': Schemas.SyncJobStatusDto;
}
export interface Response$NewsletterController_getCampaigns$Status$200 {
  'application/json': Schemas.CampaignSummaryDto[];
}
export interface Parameter$NewsletterController_getStats {
  /** Listmonk campaign id (positive integer). */
  campaignId: number;
}
export interface Response$NewsletterController_getStats$Status$200 {
  'application/json': Schemas.CampaignStatsDto;
}
export type RequestContentType$AdminAuthController_login =
  keyof RequestBody$AdminAuthController_login;
export type ResponseContentType$AdminAuthController_login =
  keyof Response$AdminAuthController_login$Status$200;
export interface Params$AdminAuthController_login {
  requestBody: RequestBody$AdminAuthController_login['application/json'];
}
export type ResponseContentType$AdminUserController_getUsers =
  keyof Response$AdminUserController_getUsers$Status$200;
export interface Params$AdminUserController_getUsers {
  parameter: Parameter$AdminUserController_getUsers;
}
export type RequestContentType$AdminUserController_updateCurrentUser =
  keyof RequestBody$AdminUserController_updateCurrentUser;
export type ResponseContentType$AdminUserController_updateCurrentUser =
  keyof Response$AdminUserController_updateCurrentUser$Status$200;
export interface Params$AdminUserController_updateCurrentUser {
  parameter: Parameter$AdminUserController_updateCurrentUser;
  requestBody: RequestBody$AdminUserController_updateCurrentUser['application/json'];
}
export type RequestContentType$AdminUserController_blockUser =
  keyof RequestBody$AdminUserController_blockUser;
export type ResponseContentType$AdminUserController_blockUser =
  keyof Response$AdminUserController_blockUser$Status$200;
export interface Params$AdminUserController_blockUser {
  parameter: Parameter$AdminUserController_blockUser;
  requestBody: RequestBody$AdminUserController_blockUser['application/json'];
}
export type ResponseContentType$AdminUserController_unblockUser =
  keyof Response$AdminUserController_unblockUser$Status$200;
export interface Params$AdminUserController_unblockUser {
  parameter: Parameter$AdminUserController_unblockUser;
}
export type ResponseContentType$AdminUserController_getCurrentUser =
  keyof Response$AdminUserController_getCurrentUser$Status$200;
export type ResponseContentType$AdminCompanyController_findAll =
  keyof Response$AdminCompanyController_findAll$Status$200;
export interface Params$AdminCompanyController_findAll {
  parameter: Parameter$AdminCompanyController_findAll;
}
export type ResponseContentType$AdminCompanyController_getAllPromoCodes =
  keyof Response$AdminCompanyController_getAllPromoCodes$Status$200;
export type ResponseContentType$AdminCompanyController_listMemberships =
  keyof Response$AdminCompanyController_listMemberships$Status$200;
export interface Params$AdminCompanyController_listMemberships {
  parameter: Parameter$AdminCompanyController_listMemberships;
}
export type ResponseContentType$AdminCompanyController_findOneById =
  keyof Response$AdminCompanyController_findOneById$Status$200;
export interface Params$AdminCompanyController_findOneById {
  parameter: Parameter$AdminCompanyController_findOneById;
}
export type RequestContentType$AdminCompanyController_updateOneById =
  keyof RequestBody$AdminCompanyController_updateOneById;
export type ResponseContentType$AdminCompanyController_updateOneById =
  keyof Response$AdminCompanyController_updateOneById$Status$200;
export interface Params$AdminCompanyController_updateOneById {
  parameter: Parameter$AdminCompanyController_updateOneById;
  requestBody: RequestBody$AdminCompanyController_updateOneById['application/json'];
}
export type RequestContentType$AdminCompanyController_addUser =
  keyof RequestBody$AdminCompanyController_addUser;
export type ResponseContentType$AdminCompanyController_addUser =
  keyof Response$AdminCompanyController_addUser$Status$201;
export interface Params$AdminCompanyController_addUser {
  parameter: Parameter$AdminCompanyController_addUser;
  requestBody: RequestBody$AdminCompanyController_addUser['application/json'];
}
export type ResponseContentType$AdminCompanyController_removeUser =
  keyof Response$AdminCompanyController_removeUser$Status$200;
export interface Params$AdminCompanyController_removeUser {
  parameter: Parameter$AdminCompanyController_removeUser;
}
export type RequestContentType$AdminObligationFileController_create =
  keyof RequestBody$AdminObligationFileController_create;
export type ResponseContentType$AdminObligationFileController_create =
  keyof Response$AdminObligationFileController_create$Status$201;
export interface Params$AdminObligationFileController_create {
  parameter: Parameter$AdminObligationFileController_create;
  requestBody: RequestBody$AdminObligationFileController_create['multipart/form-data'];
}
export type ResponseContentType$AdminObligationFileController_delete =
  keyof Response$AdminObligationFileController_delete$Status$200;
export interface Params$AdminObligationFileController_delete {
  parameter: Parameter$AdminObligationFileController_delete;
}
export type RequestContentType$AdminObligationFileController_updateOneById =
  keyof RequestBody$AdminObligationFileController_updateOneById;
export type ResponseContentType$AdminObligationFileController_updateOneById =
  keyof Response$AdminObligationFileController_updateOneById$Status$200;
export interface Params$AdminObligationFileController_updateOneById {
  parameter: Parameter$AdminObligationFileController_updateOneById;
  requestBody: RequestBody$AdminObligationFileController_updateOneById['application/json'];
}
export type ResponseContentType$AdminTransactionController_findAll =
  keyof Response$AdminTransactionController_findAll$Status$200;
export interface Params$AdminTransactionController_findAll {
  parameter: Parameter$AdminTransactionController_findAll;
}
export type ResponseContentType$AdminTransactionController_toExcel =
  keyof Response$AdminTransactionController_toExcel$Status$200;
export interface Params$AdminTransactionController_toExcel {
  parameter: Parameter$AdminTransactionController_toExcel;
}
export type ResponseContentType$AdminTransactionController_findOneById =
  keyof Response$AdminTransactionController_findOneById$Status$200;
export interface Params$AdminTransactionController_findOneById {
  parameter: Parameter$AdminTransactionController_findOneById;
}
export type RequestContentType$AdminTransactionController_updateOneById =
  keyof RequestBody$AdminTransactionController_updateOneById;
export type ResponseContentType$AdminTransactionController_updateOneById =
  keyof Response$AdminTransactionController_updateOneById$Status$200;
export interface Params$AdminTransactionController_updateOneById {
  parameter: Parameter$AdminTransactionController_updateOneById;
  requestBody: RequestBody$AdminTransactionController_updateOneById['application/json'];
}
export type ResponseContentType$AdminTransactionIngestController_findAll =
  keyof Response$AdminTransactionIngestController_findAll$Status$200;
export interface Params$AdminTransactionIngestController_findAll {
  parameter: Parameter$AdminTransactionIngestController_findAll;
}
export type ResponseContentType$AdminTransactionIngestController_findRows =
  keyof Response$AdminTransactionIngestController_findRows$Status$200;
export interface Params$AdminTransactionIngestController_findRows {
  parameter: Parameter$AdminTransactionIngestController_findRows;
}
export type ResponseContentType$AdminDocumentController_findAll =
  keyof Response$AdminDocumentController_findAll$Status$200;
export interface Params$AdminDocumentController_findAll {
  parameter: Parameter$AdminDocumentController_findAll;
}
export interface Params$AdminDocumentController_bulkDownload {
  parameter: Parameter$AdminDocumentController_bulkDownload;
}
export type ResponseContentType$AdminDocumentController_findLastParamsForContact =
  keyof Response$AdminDocumentController_findLastParamsForContact$Status$200;
export interface Params$AdminDocumentController_findLastParamsForContact {
  parameter: Parameter$AdminDocumentController_findLastParamsForContact;
}
export type ResponseContentType$AdminDocumentController_findOneById =
  keyof Response$AdminDocumentController_findOneById$Status$200;
export interface Params$AdminDocumentController_findOneById {
  parameter: Parameter$AdminDocumentController_findOneById;
}
export type RequestContentType$AdminDocumentController_updateOneById =
  keyof RequestBody$AdminDocumentController_updateOneById;
export type ResponseContentType$AdminDocumentController_updateOneById =
  keyof Response$AdminDocumentController_updateOneById$Status$200;
export interface Params$AdminDocumentController_updateOneById {
  parameter: Parameter$AdminDocumentController_updateOneById;
  requestBody: RequestBody$AdminDocumentController_updateOneById['application/json'];
}
export type RequestContentType$AdminDocumentController_bulkUpdate =
  keyof RequestBody$AdminDocumentController_bulkUpdate;
export interface Params$AdminDocumentController_bulkUpdate {
  parameter: Parameter$AdminDocumentController_bulkUpdate;
  requestBody: RequestBody$AdminDocumentController_bulkUpdate['application/json'];
}
export type ResponseContentType$AdminDocumentController_retryBobSync =
  keyof Response$AdminDocumentController_retryBobSync$Status$200;
export interface Params$AdminDocumentController_retryBobSync {
  parameter: Parameter$AdminDocumentController_retryBobSync;
}
export interface Params$AdminDocumentController_runRecognition {
  parameter: Parameter$AdminDocumentController_runRecognition;
}
export type ResponseContentType$AdminAccountsController_getAccounts =
  keyof Response$AdminAccountsController_getAccounts$Status$200;
export interface Params$AdminAccountsController_getAccounts {
  parameter: Parameter$AdminAccountsController_getAccounts;
}
export interface Params$AdminAccountsController_syncConnection {
  parameter: Parameter$AdminAccountsController_syncConnection;
}
export type ResponseContentType$AdminBalancePortfolioController_findDiscrepancies =
  keyof Response$AdminBalancePortfolioController_findDiscrepancies$Status$200;
export interface Params$AdminBalancePortfolioController_findDiscrepancies {
  parameter: Parameter$AdminBalancePortfolioController_findDiscrepancies;
}
export type ResponseContentType$AdminAccountingUsageController_list =
  keyof Response$AdminAccountingUsageController_list$Status$200;
export interface Params$AdminAccountingUsageController_list {
  parameter: Parameter$AdminAccountingUsageController_list;
}
export type ResponseContentType$AdminAccountingUsageController_getPlan =
  keyof Response$AdminAccountingUsageController_getPlan$Status$200;
export interface Params$AdminAccountingUsageController_getPlan {
  parameter: Parameter$AdminAccountingUsageController_getPlan;
}
export type RequestContentType$AdminAccountingUsageController_updatePlan =
  keyof RequestBody$AdminAccountingUsageController_updatePlan;
export type ResponseContentType$AdminAccountingUsageController_updatePlan =
  keyof Response$AdminAccountingUsageController_updatePlan$Status$200;
export interface Params$AdminAccountingUsageController_updatePlan {
  parameter: Parameter$AdminAccountingUsageController_updatePlan;
  requestBody: RequestBody$AdminAccountingUsageController_updatePlan['application/json'];
}
export type ResponseContentType$AdminMdsIncorporationsController_list =
  keyof Response$AdminMdsIncorporationsController_list$Status$200;
export interface Params$AdminMdsIncorporationsController_list {
  parameter: Parameter$AdminMdsIncorporationsController_list;
}
export type ResponseContentType$AdminMdsIncorporationsController_details =
  keyof Response$AdminMdsIncorporationsController_details$Status$200;
export interface Params$AdminMdsIncorporationsController_details {
  parameter: Parameter$AdminMdsIncorporationsController_details;
}
export type RequestContentType$AdminMdsIncorporationsController_provision =
  keyof RequestBody$AdminMdsIncorporationsController_provision;
export type ResponseContentType$AdminMdsIncorporationsController_provision =
  keyof Response$AdminMdsIncorporationsController_provision$Status$201;
export interface Params$AdminMdsIncorporationsController_provision {
  parameter: Parameter$AdminMdsIncorporationsController_provision;
  requestBody: RequestBody$AdminMdsIncorporationsController_provision['application/json'];
}
export type RequestContentType$AdminMdsIncorporationsController_syncMdsStatus =
  keyof RequestBody$AdminMdsIncorporationsController_syncMdsStatus;
export type ResponseContentType$AdminMdsIncorporationsController_syncMdsStatus =
  keyof Response$AdminMdsIncorporationsController_syncMdsStatus$Status$201;
export interface Params$AdminMdsIncorporationsController_syncMdsStatus {
  parameter: Parameter$AdminMdsIncorporationsController_syncMdsStatus;
  requestBody: RequestBody$AdminMdsIncorporationsController_syncMdsStatus['application/json'];
}
export type RequestContentType$AdminMdsIncorporationsController_refreshFromMds =
  keyof RequestBody$AdminMdsIncorporationsController_refreshFromMds;
export type ResponseContentType$AdminMdsIncorporationsController_refreshFromMds =
  keyof Response$AdminMdsIncorporationsController_refreshFromMds$Status$201;
export interface Params$AdminMdsIncorporationsController_refreshFromMds {
  parameter: Parameter$AdminMdsIncorporationsController_refreshFromMds;
  requestBody: RequestBody$AdminMdsIncorporationsController_refreshFromMds['application/json'];
}
export type ResponseContentType$AdminEventController_findAll =
  keyof Response$AdminEventController_findAll$Status$200;
export interface Params$AdminEventController_findAll {
  parameter: Parameter$AdminEventController_findAll;
}
export type ResponseContentType$AdminEventController_findMembershipJournal =
  keyof Response$AdminEventController_findMembershipJournal$Status$200;
export interface Params$AdminEventController_findMembershipJournal {
  parameter: Parameter$AdminEventController_findMembershipJournal;
}
export type ResponseContentType$AdminExportController_describeCompany =
  keyof Response$AdminExportController_describeCompany$Status$200;
export interface Params$AdminExportController_describeCompany {
  parameter: Parameter$AdminExportController_describeCompany;
}
export type ResponseContentType$AdminExportController_listContacts =
  keyof Response$AdminExportController_listContacts$Status$200;
export interface Params$AdminExportController_listContacts {
  parameter: Parameter$AdminExportController_listContacts;
}
export type ResponseContentType$AdminExportController_listBobAccounts =
  keyof Response$AdminExportController_listBobAccounts$Status$200;
export interface Params$AdminExportController_listBobAccounts {
  parameter: Parameter$AdminExportController_listBobAccounts;
}
export type ResponseContentType$AdminExportController_listBobDaybooks =
  keyof Response$AdminExportController_listBobDaybooks$Status$200;
export interface Params$AdminExportController_listBobDaybooks {
  parameter: Parameter$AdminExportController_listBobDaybooks;
}
export type ResponseContentType$AdminExportController_listAccounts =
  keyof Response$AdminExportController_listAccounts$Status$200;
export interface Params$AdminExportController_listAccounts {
  parameter: Parameter$AdminExportController_listAccounts;
}
export type ResponseContentType$AdminExportController_listDocuments =
  keyof Response$AdminExportController_listDocuments$Status$200;
export interface Params$AdminExportController_listDocuments {
  parameter: Parameter$AdminExportController_listDocuments;
}
export type ResponseContentType$AdminExportController_listBillingDocuments =
  keyof Response$AdminExportController_listBillingDocuments$Status$200;
export interface Params$AdminExportController_listBillingDocuments {
  parameter: Parameter$AdminExportController_listBillingDocuments;
}
export type ResponseContentType$AdminExportController_listTransactionIngests =
  keyof Response$AdminExportController_listTransactionIngests$Status$200;
export interface Params$AdminExportController_listTransactionIngests {
  parameter: Parameter$AdminExportController_listTransactionIngests;
}
export type ResponseContentType$AdminExportController_listTransactions =
  keyof Response$AdminExportController_listTransactions$Status$200;
export interface Params$AdminExportController_listTransactions {
  parameter: Parameter$AdminExportController_listTransactions;
}
export type ResponseContentType$AdminExportController_listTransactionDocuments =
  keyof Response$AdminExportController_listTransactionDocuments$Status$200;
export interface Params$AdminExportController_listTransactionDocuments {
  parameter: Parameter$AdminExportController_listTransactionDocuments;
}
export type ResponseContentType$AdminIncorporationController_findOneById =
  keyof Response$AdminIncorporationController_findOneById$Status$200;
export interface Params$AdminIncorporationController_findOneById {
  parameter: Parameter$AdminIncorporationController_findOneById;
}
export type RequestContentType$AdminIncorporationController_updateOneById =
  keyof RequestBody$AdminIncorporationController_updateOneById;
export type ResponseContentType$AdminIncorporationController_updateOneById =
  keyof Response$AdminIncorporationController_updateOneById$Status$200;
export interface Params$AdminIncorporationController_updateOneById {
  parameter: Parameter$AdminIncorporationController_updateOneById;
  requestBody: RequestBody$AdminIncorporationController_updateOneById['application/json'];
}
export type ResponseContentType$AdminIncorporationController_approveKyc =
  keyof Response$AdminIncorporationController_approveKyc$Status$200;
export interface Params$AdminIncorporationController_approveKyc {
  parameter: Parameter$AdminIncorporationController_approveKyc;
}
export type ResponseContentType$AdminIncorporationController_failKyc =
  keyof Response$AdminIncorporationController_failKyc$Status$200;
export interface Params$AdminIncorporationController_failKyc {
  parameter: Parameter$AdminIncorporationController_failKyc;
}
export type ResponseContentType$AdminCompanyFileController_findAll =
  keyof Response$AdminCompanyFileController_findAll$Status$200;
export interface Params$AdminCompanyFileController_findAll {
  parameter: Parameter$AdminCompanyFileController_findAll;
}
export type RequestContentType$AdminCompanyFileController_create =
  keyof RequestBody$AdminCompanyFileController_create;
export type ResponseContentType$AdminCompanyFileController_create =
  keyof Response$AdminCompanyFileController_create$Status$201;
export interface Params$AdminCompanyFileController_create {
  parameter: Parameter$AdminCompanyFileController_create;
  requestBody: RequestBody$AdminCompanyFileController_create['multipart/form-data'];
}
export type RequestContentType$AdminCompanyFileController_createFromTaskFile =
  keyof RequestBody$AdminCompanyFileController_createFromTaskFile;
export type ResponseContentType$AdminCompanyFileController_createFromTaskFile =
  keyof Response$AdminCompanyFileController_createFromTaskFile$Status$201;
export interface Params$AdminCompanyFileController_createFromTaskFile {
  parameter: Parameter$AdminCompanyFileController_createFromTaskFile;
  requestBody: RequestBody$AdminCompanyFileController_createFromTaskFile['application/json'];
}
export type ResponseContentType$AdminCompanyFileController_delete =
  keyof Response$AdminCompanyFileController_delete$Status$200;
export interface Params$AdminCompanyFileController_delete {
  parameter: Parameter$AdminCompanyFileController_delete;
}
export type RequestContentType$AdminCompanyFileController_updateOneById =
  keyof RequestBody$AdminCompanyFileController_updateOneById;
export type ResponseContentType$AdminCompanyFileController_updateOneById =
  keyof Response$AdminCompanyFileController_updateOneById$Status$200;
export interface Params$AdminCompanyFileController_updateOneById {
  parameter: Parameter$AdminCompanyFileController_updateOneById;
  requestBody: RequestBody$AdminCompanyFileController_updateOneById['multipart/form-data'];
}
export type ResponseContentType$AdminOnfidoDataController_create =
  keyof Response$AdminOnfidoDataController_create$Status$200;
export interface Params$AdminOnfidoDataController_create {
  parameter: Parameter$AdminOnfidoDataController_create;
}
export type ResponseContentType$AdminOnfidoDataController_generateLink =
  keyof Response$AdminOnfidoDataController_generateLink$Status$200;
export interface Params$AdminOnfidoDataController_generateLink {
  parameter: Parameter$AdminOnfidoDataController_generateLink;
}
export type ResponseContentType$AdminSumsubDataController_findForPerson =
  keyof Response$AdminSumsubDataController_findForPerson$Status$200;
export interface Params$AdminSumsubDataController_findForPerson {
  parameter: Parameter$AdminSumsubDataController_findForPerson;
}
export type ResponseContentType$AdminSumsubDataController_generateLink =
  keyof Response$AdminSumsubDataController_generateLink$Status$200;
export interface Params$AdminSumsubDataController_generateLink {
  parameter: Parameter$AdminSumsubDataController_generateLink;
}
export type ResponseContentType$AdminTaskController_findAll =
  keyof Response$AdminTaskController_findAll$Status$200;
export interface Params$AdminTaskController_findAll {
  parameter: Parameter$AdminTaskController_findAll;
}
export type RequestContentType$AdminTaskController_create =
  keyof RequestBody$AdminTaskController_create;
export type ResponseContentType$AdminTaskController_create =
  keyof Response$AdminTaskController_create$Status$201;
export interface Params$AdminTaskController_create {
  requestBody: RequestBody$AdminTaskController_create['application/json'];
}
export type RequestContentType$AdminTaskController_createV2 =
  keyof RequestBody$AdminTaskController_createV2;
export type ResponseContentType$AdminTaskController_createV2 =
  keyof Response$AdminTaskController_createV2$Status$201;
export interface Params$AdminTaskController_createV2 {
  requestBody: RequestBody$AdminTaskController_createV2['application/json'];
}
export type RequestContentType$AdminTaskController_updateOneById =
  keyof RequestBody$AdminTaskController_updateOneById;
export type ResponseContentType$AdminTaskController_updateOneById =
  keyof Response$AdminTaskController_updateOneById$Status$200;
export interface Params$AdminTaskController_updateOneById {
  parameter: Parameter$AdminTaskController_updateOneById;
  requestBody: RequestBody$AdminTaskController_updateOneById['application/json'];
}
export type ResponseContentType$AdminTaskController_close =
  keyof Response$AdminTaskController_close$Status$200;
export interface Params$AdminTaskController_close {
  parameter: Parameter$AdminTaskController_close;
}
export type RequestContentType$AdminTaskFileController_create =
  keyof RequestBody$AdminTaskFileController_create;
export type ResponseContentType$AdminTaskFileController_create =
  keyof Response$AdminTaskFileController_create$Status$201;
export interface Params$AdminTaskFileController_create {
  parameter: Parameter$AdminTaskFileController_create;
  requestBody: RequestBody$AdminTaskFileController_create['multipart/form-data'];
}
export type ResponseContentType$AdminBillingPeriodController_findAllUnapproved =
  keyof Response$AdminBillingPeriodController_findAllUnapproved$Status$200;
export type ResponseContentType$AdminBillingPeriodController_findAll =
  keyof Response$AdminBillingPeriodController_findAll$Status$200;
export interface Params$AdminBillingPeriodController_findAll {
  parameter: Parameter$AdminBillingPeriodController_findAll;
}
export type RequestContentType$AdminBillingPeriodController_create =
  keyof RequestBody$AdminBillingPeriodController_create;
export type ResponseContentType$AdminBillingPeriodController_create =
  keyof Response$AdminBillingPeriodController_create$Status$201;
export interface Params$AdminBillingPeriodController_create {
  parameter: Parameter$AdminBillingPeriodController_create;
  requestBody: RequestBody$AdminBillingPeriodController_create['application/json'];
}
export type ResponseContentType$AdminBillingPeriodController_findOneById =
  keyof Response$AdminBillingPeriodController_findOneById$Status$200;
export interface Params$AdminBillingPeriodController_findOneById {
  parameter: Parameter$AdminBillingPeriodController_findOneById;
}
export type ResponseContentType$AdminBillingPeriodController_delete =
  keyof Response$AdminBillingPeriodController_delete$Status$200;
export interface Params$AdminBillingPeriodController_delete {
  parameter: Parameter$AdminBillingPeriodController_delete;
}
export type RequestContentType$AdminBillingPeriodController_updateOneById =
  keyof RequestBody$AdminBillingPeriodController_updateOneById;
export type ResponseContentType$AdminBillingPeriodController_updateOneById =
  keyof Response$AdminBillingPeriodController_updateOneById$Status$200;
export interface Params$AdminBillingPeriodController_updateOneById {
  parameter: Parameter$AdminBillingPeriodController_updateOneById;
  requestBody: RequestBody$AdminBillingPeriodController_updateOneById['application/json'];
}
export type ResponseContentType$AdminBillingPeriodController_approve =
  keyof Response$AdminBillingPeriodController_approve$Status$200;
export interface Params$AdminBillingPeriodController_approve {
  parameter: Parameter$AdminBillingPeriodController_approve;
}
export type ResponseContentType$AdminBobAccountController_findAll =
  keyof Response$AdminBobAccountController_findAll$Status$200;
export interface Params$AdminBobAccountController_findAll {
  parameter: Parameter$AdminBobAccountController_findAll;
}
export type ResponseContentType$AdminBobDaybookController_findAll =
  keyof Response$AdminBobDaybookController_findAll$Status$200;
export interface Params$AdminBobDaybookController_findAll {
  parameter: Parameter$AdminBobDaybookController_findAll;
}
export type ResponseContentType$AdminBobVATController_findAll =
  keyof Response$AdminBobVATController_findAll$Status$200;
export interface Params$AdminBobVATController_findAll {
  parameter: Parameter$AdminBobVATController_findAll;
}
export type ResponseContentType$AdminBobContactController_findAll =
  keyof Response$AdminBobContactController_findAll$Status$200;
export interface Params$AdminBobContactController_findAll {
  parameter: Parameter$AdminBobContactController_findAll;
}
export type RequestContentType$AdminBobContactController_create =
  keyof RequestBody$AdminBobContactController_create;
export type ResponseContentType$AdminBobContactController_create =
  keyof Response$AdminBobContactController_create$Status$201;
export interface Params$AdminBobContactController_create {
  parameter: Parameter$AdminBobContactController_create;
  requestBody: RequestBody$AdminBobContactController_create['application/json'];
}
export type ResponseContentType$AdminBobContactController_suggestBobId =
  keyof Response$AdminBobContactController_suggestBobId$Status$200;
export interface Params$AdminBobContactController_suggestBobId {
  parameter: Parameter$AdminBobContactController_suggestBobId;
}
export type ResponseContentType$AdminProcessTemplateController_findAll =
  keyof Response$AdminProcessTemplateController_findAll$Status$200;
export interface Params$AdminProcessTemplateController_findAll {
  parameter: Parameter$AdminProcessTemplateController_findAll;
}
export type RequestContentType$AdminProcessTemplateController_create =
  keyof RequestBody$AdminProcessTemplateController_create;
export type ResponseContentType$AdminProcessTemplateController_create =
  keyof Response$AdminProcessTemplateController_create$Status$201;
export interface Params$AdminProcessTemplateController_create {
  requestBody: RequestBody$AdminProcessTemplateController_create['application/json'];
}
export type ResponseContentType$AdminProcessTemplateController_findOneById =
  keyof Response$AdminProcessTemplateController_findOneById$Status$200;
export interface Params$AdminProcessTemplateController_findOneById {
  parameter: Parameter$AdminProcessTemplateController_findOneById;
}
export interface Params$AdminProcessTemplateController_delete {
  parameter: Parameter$AdminProcessTemplateController_delete;
}
export type RequestContentType$AdminProcessTemplateController_update =
  keyof RequestBody$AdminProcessTemplateController_update;
export type ResponseContentType$AdminProcessTemplateController_update =
  keyof Response$AdminProcessTemplateController_update$Status$200;
export interface Params$AdminProcessTemplateController_update {
  parameter: Parameter$AdminProcessTemplateController_update;
  requestBody: RequestBody$AdminProcessTemplateController_update['application/json'];
}
export interface Params$AdminProcessTemplateController_publish {
  parameter: Parameter$AdminProcessTemplateController_publish;
}
export interface Params$AdminProcessTemplateController_unpublish {
  parameter: Parameter$AdminProcessTemplateController_unpublish;
}
export type ResponseContentType$AdminStepController_findAll =
  keyof Response$AdminStepController_findAll$Status$200;
export interface Params$AdminStepController_findAll {
  parameter: Parameter$AdminStepController_findAll;
}
export type RequestContentType$AdminStepController_create =
  keyof RequestBody$AdminStepController_create;
export type ResponseContentType$AdminStepController_create =
  keyof Response$AdminStepController_create$Status$201;
export interface Params$AdminStepController_create {
  requestBody: RequestBody$AdminStepController_create['application/json'];
}
export interface Params$AdminStepController_delete {
  parameter: Parameter$AdminStepController_delete;
}
export type RequestContentType$AdminStepController_update =
  keyof RequestBody$AdminStepController_update;
export type ResponseContentType$AdminStepController_update =
  keyof Response$AdminStepController_update$Status$200;
export interface Params$AdminStepController_update {
  parameter: Parameter$AdminStepController_update;
  requestBody: RequestBody$AdminStepController_update['application/json'];
}
export type ResponseContentType$AdminPayslipDocumentController_findAll =
  keyof Response$AdminPayslipDocumentController_findAll$Status$200;
export interface Params$AdminPayslipDocumentController_findAll {
  parameter: Parameter$AdminPayslipDocumentController_findAll;
}
export type RequestContentType$AdminPayslipDocumentController_create =
  keyof RequestBody$AdminPayslipDocumentController_create;
export interface Params$AdminPayslipDocumentController_create {
  parameter: Parameter$AdminPayslipDocumentController_create;
  requestBody: RequestBody$AdminPayslipDocumentController_create['multipart/form-data'];
}
export type ResponseContentType$AdminPayslipDocumentController_findOneById =
  keyof Response$AdminPayslipDocumentController_findOneById$Status$200;
export interface Params$AdminPayslipDocumentController_findOneById {
  parameter: Parameter$AdminPayslipDocumentController_findOneById;
}
export type ResponseContentType$AdminPayslipDocumentController_delete =
  keyof Response$AdminPayslipDocumentController_delete$Status$200;
export interface Params$AdminPayslipDocumentController_delete {
  parameter: Parameter$AdminPayslipDocumentController_delete;
}
export type RequestContentType$AdminPayslipDocumentController_updateOneById =
  keyof RequestBody$AdminPayslipDocumentController_updateOneById;
export interface Params$AdminPayslipDocumentController_updateOneById {
  parameter: Parameter$AdminPayslipDocumentController_updateOneById;
  requestBody: RequestBody$AdminPayslipDocumentController_updateOneById['multipart/form-data'];
}
export type ResponseContentType$AdminBillingDocumentController_findAllOneTimeInvoices =
  keyof Response$AdminBillingDocumentController_findAllOneTimeInvoices$Status$200;
export interface Params$AdminBillingDocumentController_findAllOneTimeInvoices {
  parameter: Parameter$AdminBillingDocumentController_findAllOneTimeInvoices;
}
export type RequestContentType$AdminBillingDocumentController_createOneTimeInvoice =
  keyof RequestBody$AdminBillingDocumentController_createOneTimeInvoice;
export type ResponseContentType$AdminBillingDocumentController_createOneTimeInvoice =
  keyof Response$AdminBillingDocumentController_createOneTimeInvoice$Status$201;
export interface Params$AdminBillingDocumentController_createOneTimeInvoice {
  parameter: Parameter$AdminBillingDocumentController_createOneTimeInvoice;
  requestBody: RequestBody$AdminBillingDocumentController_createOneTimeInvoice['application/json'];
}
export type RequestContentType$AdminBillingDocumentController_createCreditNote =
  keyof RequestBody$AdminBillingDocumentController_createCreditNote;
export interface Params$AdminBillingDocumentController_createCreditNote {
  parameter: Parameter$AdminBillingDocumentController_createCreditNote;
  requestBody: RequestBody$AdminBillingDocumentController_createCreditNote['application/json'];
}
export type RequestContentType$AdminBillingDocumentController_createCreditNoteV3 =
  keyof RequestBody$AdminBillingDocumentController_createCreditNoteV3;
export type ResponseContentType$AdminBillingDocumentController_createCreditNoteV3 =
  keyof Response$AdminBillingDocumentController_createCreditNoteV3$Status$201;
export interface Params$AdminBillingDocumentController_createCreditNoteV3 {
  parameter: Parameter$AdminBillingDocumentController_createCreditNoteV3;
  requestBody: RequestBody$AdminBillingDocumentController_createCreditNoteV3['application/json'];
}
export type ResponseContentType$AdminBillingDocumentController_getCreditNoteCapabilities =
  keyof Response$AdminBillingDocumentController_getCreditNoteCapabilities$Status$200;
export interface Params$AdminBillingDocumentController_getCreditNoteCapabilities {
  parameter: Parameter$AdminBillingDocumentController_getCreditNoteCapabilities;
}
export type ResponseContentType$AdminBillingDocumentController_findOneById =
  keyof Response$AdminBillingDocumentController_findOneById$Status$200;
export interface Params$AdminBillingDocumentController_findOneById {
  parameter: Parameter$AdminBillingDocumentController_findOneById;
}
export type ResponseContentType$AdminBillingDocumentController_delete =
  keyof Response$AdminBillingDocumentController_delete$Status$200;
export interface Params$AdminBillingDocumentController_delete {
  parameter: Parameter$AdminBillingDocumentController_delete;
}
export type RequestContentType$AdminBillingDocumentController_updateOneById =
  keyof RequestBody$AdminBillingDocumentController_updateOneById;
export type ResponseContentType$AdminBillingDocumentController_updateOneById =
  keyof Response$AdminBillingDocumentController_updateOneById$Status$200;
export interface Params$AdminBillingDocumentController_updateOneById {
  parameter: Parameter$AdminBillingDocumentController_updateOneById;
  requestBody: RequestBody$AdminBillingDocumentController_updateOneById['application/json'];
}
export type RequestContentType$AdminBillingDocumentController_create =
  keyof RequestBody$AdminBillingDocumentController_create;
export type ResponseContentType$AdminBillingDocumentController_create =
  keyof Response$AdminBillingDocumentController_create$Status$201;
export interface Params$AdminBillingDocumentController_create {
  parameter: Parameter$AdminBillingDocumentController_create;
  requestBody: RequestBody$AdminBillingDocumentController_create['multipart/form-data'];
}
export type ResponseContentType$AdminCurrencyExchangeRateController_getRate =
  keyof Response$AdminCurrencyExchangeRateController_getRate$Status$200;
export interface Params$AdminCurrencyExchangeRateController_getRate {
  parameter: Parameter$AdminCurrencyExchangeRateController_getRate;
}
export type ResponseContentType$AdminPersonsController_findAll =
  keyof Response$AdminPersonsController_findAll$Status$200;
export interface Params$AdminPersonsController_findAll {
  parameter: Parameter$AdminPersonsController_findAll;
}
export type RequestContentType$AdminPersonsController_create =
  keyof RequestBody$AdminPersonsController_create;
export type ResponseContentType$AdminPersonsController_create =
  keyof Response$AdminPersonsController_create$Status$201;
export interface Params$AdminPersonsController_create {
  parameter: Parameter$AdminPersonsController_create;
  requestBody: RequestBody$AdminPersonsController_create['application/json'];
}
export type ResponseContentType$AdminPersonsController_findOne =
  keyof Response$AdminPersonsController_findOne$Status$200;
export interface Params$AdminPersonsController_findOne {
  parameter: Parameter$AdminPersonsController_findOne;
}
export type RequestContentType$AdminPersonsController_update =
  keyof RequestBody$AdminPersonsController_update;
export type ResponseContentType$AdminPersonsController_update =
  keyof Response$AdminPersonsController_update$Status$200;
export interface Params$AdminPersonsController_update {
  parameter: Parameter$AdminPersonsController_update;
  requestBody: RequestBody$AdminPersonsController_update['application/json'];
}
export interface Params$AdminPersonsController_remove {
  parameter: Parameter$AdminPersonsController_remove;
}
export interface Params$AdminPersonsController_assignUboNumber {
  parameter: Parameter$AdminPersonsController_assignUboNumber;
}
export type ResponseContentType$AdminObligationController_findAll =
  keyof Response$AdminObligationController_findAll$Status$200;
export interface Params$AdminObligationController_findAll {
  parameter: Parameter$AdminObligationController_findAll;
}
export type RequestContentType$AdminObligationController_create =
  keyof RequestBody$AdminObligationController_create;
export type ResponseContentType$AdminObligationController_create =
  keyof Response$AdminObligationController_create$Status$201;
export interface Params$AdminObligationController_create {
  parameter: Parameter$AdminObligationController_create;
  requestBody: RequestBody$AdminObligationController_create['application/json'];
}
export type ResponseContentType$AdminObligationController_findOneById =
  keyof Response$AdminObligationController_findOneById$Status$200;
export interface Params$AdminObligationController_findOneById {
  parameter: Parameter$AdminObligationController_findOneById;
}
export type ResponseContentType$AdminObligationController_deleteOneById =
  keyof Response$AdminObligationController_deleteOneById$Status$200;
export interface Params$AdminObligationController_deleteOneById {
  parameter: Parameter$AdminObligationController_deleteOneById;
}
export type RequestContentType$AdminObligationController_updateOneById =
  keyof RequestBody$AdminObligationController_updateOneById;
export type ResponseContentType$AdminObligationController_updateOneById =
  keyof Response$AdminObligationController_updateOneById$Status$200;
export interface Params$AdminObligationController_updateOneById {
  parameter: Parameter$AdminObligationController_updateOneById;
  requestBody: RequestBody$AdminObligationController_updateOneById['application/json'];
}
export type ResponseContentType$AdminObligationController_findEventsById =
  keyof Response$AdminObligationController_findEventsById$Status$200;
export interface Params$AdminObligationController_findEventsById {
  parameter: Parameter$AdminObligationController_findEventsById;
}
export type ResponseContentType$NewsletterController_getRecipients =
  keyof Response$NewsletterController_getRecipients$Status$200;
export interface Params$NewsletterController_getRecipients {
  parameter: Parameter$NewsletterController_getRecipients;
}
export type RequestContentType$NewsletterController_sync =
  keyof RequestBody$NewsletterController_sync;
export type ResponseContentType$NewsletterController_sync =
  keyof Response$NewsletterController_sync$Status$201;
export interface Params$NewsletterController_sync {
  requestBody: RequestBody$NewsletterController_sync['application/json'];
}
export type ResponseContentType$NewsletterController_syncStatus =
  keyof Response$NewsletterController_syncStatus$Status$200;
export interface Params$NewsletterController_syncStatus {
  parameter: Parameter$NewsletterController_syncStatus;
}
export type ResponseContentType$NewsletterController_getCampaigns =
  keyof Response$NewsletterController_getCampaigns$Status$200;
export type ResponseContentType$NewsletterController_getStats =
  keyof Response$NewsletterController_getStats$Status$200;
export interface Params$NewsletterController_getStats {
  parameter: Parameter$NewsletterController_getStats;
}
export type HttpMethod =
  | 'GET'
  | 'PUT'
  | 'POST'
  | 'DELETE'
  | 'OPTIONS'
  | 'HEAD'
  | 'PATCH'
  | 'TRACE';
export interface ObjectLike {
  [key: string]: any;
}
export interface QueryParameter {
  value: any;
  style?: 'form' | 'spaceDelimited' | 'pipeDelimited' | 'deepObject';
  explode: boolean;
}
export interface QueryParameters {
  [key: string]: QueryParameter;
}
export type SuccessResponses =
  | Response$AdminAuthController_login$Status$200
  | Response$AdminUserController_getUsers$Status$200
  | Response$AdminUserController_updateCurrentUser$Status$200
  | Response$AdminUserController_blockUser$Status$200
  | Response$AdminUserController_unblockUser$Status$200
  | Response$AdminUserController_getCurrentUser$Status$200
  | Response$AdminCompanyController_findAll$Status$200
  | Response$AdminCompanyController_getAllPromoCodes$Status$200
  | Response$AdminCompanyController_listMemberships$Status$200
  | Response$AdminCompanyController_findOneById$Status$200
  | Response$AdminCompanyController_updateOneById$Status$200
  | Response$AdminCompanyController_addUser$Status$201
  | Response$AdminCompanyController_removeUser$Status$200
  | Response$AdminObligationFileController_create$Status$201
  | Response$AdminObligationFileController_delete$Status$200
  | Response$AdminObligationFileController_updateOneById$Status$200
  | Response$AdminTransactionController_findAll$Status$200
  | Response$AdminTransactionController_toExcel$Status$200
  | Response$AdminTransactionController_findOneById$Status$200
  | Response$AdminTransactionController_updateOneById$Status$200
  | Response$AdminTransactionIngestController_findAll$Status$200
  | Response$AdminTransactionIngestController_findRows$Status$200
  | Response$AdminDocumentController_findAll$Status$200
  | Response$AdminDocumentController_findLastParamsForContact$Status$200
  | Response$AdminDocumentController_findOneById$Status$200
  | Response$AdminDocumentController_updateOneById$Status$200
  | Response$AdminDocumentController_retryBobSync$Status$200
  | Response$AdminAccountsController_getAccounts$Status$200
  | Response$AdminBalancePortfolioController_findDiscrepancies$Status$200
  | Response$AdminAccountingUsageController_list$Status$200
  | Response$AdminAccountingUsageController_getPlan$Status$200
  | Response$AdminAccountingUsageController_updatePlan$Status$200
  | Response$AdminMdsIncorporationsController_list$Status$200
  | Response$AdminMdsIncorporationsController_details$Status$200
  | Response$AdminMdsIncorporationsController_provision$Status$201
  | Response$AdminMdsIncorporationsController_syncMdsStatus$Status$201
  | Response$AdminMdsIncorporationsController_refreshFromMds$Status$201
  | Response$AdminEventController_findAll$Status$200
  | Response$AdminEventController_findMembershipJournal$Status$200
  | Response$AdminExportController_describeCompany$Status$200
  | Response$AdminExportController_listContacts$Status$200
  | Response$AdminExportController_listBobAccounts$Status$200
  | Response$AdminExportController_listBobDaybooks$Status$200
  | Response$AdminExportController_listAccounts$Status$200
  | Response$AdminExportController_listDocuments$Status$200
  | Response$AdminExportController_listBillingDocuments$Status$200
  | Response$AdminExportController_listTransactionIngests$Status$200
  | Response$AdminExportController_listTransactions$Status$200
  | Response$AdminExportController_listTransactionDocuments$Status$200
  | Response$AdminIncorporationController_findOneById$Status$200
  | Response$AdminIncorporationController_updateOneById$Status$200
  | Response$AdminIncorporationController_approveKyc$Status$200
  | Response$AdminIncorporationController_failKyc$Status$200
  | Response$AdminCompanyFileController_findAll$Status$200
  | Response$AdminCompanyFileController_create$Status$201
  | Response$AdminCompanyFileController_createFromTaskFile$Status$201
  | Response$AdminCompanyFileController_delete$Status$200
  | Response$AdminCompanyFileController_updateOneById$Status$200
  | Response$AdminOnfidoDataController_create$Status$200
  | Response$AdminOnfidoDataController_generateLink$Status$200
  | Response$AdminOnfidoDataController_generateLink$Status$201
  | Response$AdminSumsubDataController_findForPerson$Status$200
  | Response$AdminSumsubDataController_generateLink$Status$200
  | Response$AdminSumsubDataController_generateLink$Status$201
  | Response$AdminTaskController_findAll$Status$200
  | Response$AdminTaskController_create$Status$201
  | Response$AdminTaskController_createV2$Status$201
  | Response$AdminTaskController_updateOneById$Status$200
  | Response$AdminTaskController_close$Status$200
  | Response$AdminTaskFileController_create$Status$201
  | Response$AdminBillingPeriodController_findAllUnapproved$Status$200
  | Response$AdminBillingPeriodController_findAll$Status$200
  | Response$AdminBillingPeriodController_create$Status$201
  | Response$AdminBillingPeriodController_findOneById$Status$200
  | Response$AdminBillingPeriodController_delete$Status$200
  | Response$AdminBillingPeriodController_updateOneById$Status$200
  | Response$AdminBillingPeriodController_approve$Status$200
  | Response$AdminBobAccountController_findAll$Status$200
  | Response$AdminBobDaybookController_findAll$Status$200
  | Response$AdminBobVATController_findAll$Status$200
  | Response$AdminBobContactController_findAll$Status$200
  | Response$AdminBobContactController_create$Status$201
  | Response$AdminBobContactController_suggestBobId$Status$200
  | Response$AdminProcessTemplateController_findAll$Status$200
  | Response$AdminProcessTemplateController_create$Status$201
  | Response$AdminProcessTemplateController_findOneById$Status$200
  | Response$AdminProcessTemplateController_update$Status$200
  | Response$AdminStepController_findAll$Status$200
  | Response$AdminStepController_create$Status$201
  | Response$AdminStepController_update$Status$200
  | Response$AdminPayslipDocumentController_findAll$Status$200
  | Response$AdminPayslipDocumentController_findOneById$Status$200
  | Response$AdminPayslipDocumentController_delete$Status$200
  | Response$AdminBillingDocumentController_findAllOneTimeInvoices$Status$200
  | Response$AdminBillingDocumentController_createOneTimeInvoice$Status$201
  | Response$AdminBillingDocumentController_createCreditNoteV3$Status$201
  | Response$AdminBillingDocumentController_getCreditNoteCapabilities$Status$200
  | Response$AdminBillingDocumentController_findOneById$Status$200
  | Response$AdminBillingDocumentController_delete$Status$200
  | Response$AdminBillingDocumentController_updateOneById$Status$200
  | Response$AdminBillingDocumentController_create$Status$201
  | Response$AdminCurrencyExchangeRateController_getRate$Status$200
  | Response$AdminPersonsController_findAll$Status$200
  | Response$AdminPersonsController_create$Status$201
  | Response$AdminPersonsController_findOne$Status$200
  | Response$AdminPersonsController_update$Status$200
  | Response$AdminObligationController_findAll$Status$200
  | Response$AdminObligationController_create$Status$201
  | Response$AdminObligationController_findOneById$Status$200
  | Response$AdminObligationController_deleteOneById$Status$200
  | Response$AdminObligationController_updateOneById$Status$200
  | Response$AdminObligationController_findEventsById$Status$200
  | Response$NewsletterController_getRecipients$Status$200
  | Response$NewsletterController_sync$Status$201
  | Response$NewsletterController_syncStatus$Status$200
  | Response$NewsletterController_getCampaigns$Status$200
  | Response$NewsletterController_getStats$Status$200;
export namespace ErrorResponse {
  export type AdminAuthController_login = void;
  export type AdminUserController_getUsers = void;
  export type AdminUserController_updateCurrentUser = void;
  export type AdminUserController_blockUser = void;
  export type AdminUserController_unblockUser = void;
  export type AdminUserController_getCurrentUser = void;
  export type AdminCompanyController_findAll = void;
  export type AdminCompanyController_getAllPromoCodes = void;
  export type AdminCompanyController_listMemberships = void;
  export type AdminCompanyController_findOneById = void;
  export type AdminCompanyController_updateOneById = void;
  export type AdminCompanyController_addUser = void;
  export type AdminCompanyController_removeUser = void;
  export type AdminObligationFileController_create = void;
  export type AdminObligationFileController_delete = void;
  export type AdminObligationFileController_updateOneById = void;
  export type AdminTransactionController_findAll = void;
  export type AdminTransactionController_toExcel = void;
  export type AdminTransactionController_findOneById = void;
  export type AdminTransactionController_updateOneById = void;
  export type AdminTransactionIngestController_findAll = void;
  export type AdminTransactionIngestController_findRows = void;
  export type AdminDocumentController_findAll = void;
  export type AdminDocumentController_bulkDownload = void;
  export type AdminDocumentController_findLastParamsForContact = void;
  export type AdminDocumentController_findOneById = void;
  export type AdminDocumentController_updateOneById = void;
  export type AdminDocumentController_bulkUpdate = void;
  export type AdminDocumentController_retryBobSync =
    | Response$AdminDocumentController_retryBobSync$Status$400
    | Response$AdminDocumentController_retryBobSync$Status$409;
  export type AdminDocumentController_runRecognition = void;
  export type AdminAccountsController_getAccounts = void;
  export type AdminAccountsController_syncConnection = void;
  export type AdminBalancePortfolioController_findDiscrepancies = void;
  export type AdminAccountingUsageController_list = void;
  export type AdminAccountingUsageController_getPlan = void;
  export type AdminAccountingUsageController_updatePlan = void;
  export type AdminMdsIncorporationsController_list = void;
  export type AdminMdsIncorporationsController_details = void;
  export type AdminMdsIncorporationsController_provision = void;
  export type AdminMdsIncorporationsController_syncMdsStatus = void;
  export type AdminMdsIncorporationsController_refreshFromMds = void;
  export type AdminEventController_findAll = void;
  export type AdminEventController_findMembershipJournal = void;
  export type AdminExportController_describeCompany = void;
  export type AdminExportController_listContacts = void;
  export type AdminExportController_listBobAccounts = void;
  export type AdminExportController_listBobDaybooks = void;
  export type AdminExportController_listAccounts = void;
  export type AdminExportController_listDocuments = void;
  export type AdminExportController_listBillingDocuments = void;
  export type AdminExportController_listTransactionIngests = void;
  export type AdminExportController_listTransactions = void;
  export type AdminExportController_listTransactionDocuments = void;
  export type AdminIncorporationController_findOneById = void;
  export type AdminIncorporationController_updateOneById = void;
  export type AdminIncorporationController_approveKyc = void;
  export type AdminIncorporationController_failKyc = void;
  export type AdminCompanyFileController_findAll = void;
  export type AdminCompanyFileController_create = void;
  export type AdminCompanyFileController_createFromTaskFile = void;
  export type AdminCompanyFileController_delete = void;
  export type AdminCompanyFileController_updateOneById = void;
  export type AdminOnfidoDataController_create = void;
  export type AdminOnfidoDataController_generateLink = void;
  export type AdminSumsubDataController_findForPerson = void;
  export type AdminSumsubDataController_generateLink = void;
  export type AdminTaskController_findAll = void;
  export type AdminTaskController_create = void;
  export type AdminTaskController_createV2 = void;
  export type AdminTaskController_updateOneById = void;
  export type AdminTaskController_close = void;
  export type AdminTaskFileController_create = void;
  export type AdminBillingPeriodController_findAllUnapproved = void;
  export type AdminBillingPeriodController_findAll = void;
  export type AdminBillingPeriodController_create = void;
  export type AdminBillingPeriodController_findOneById = void;
  export type AdminBillingPeriodController_delete = void;
  export type AdminBillingPeriodController_updateOneById = void;
  export type AdminBillingPeriodController_approve = void;
  export type AdminBobAccountController_findAll = void;
  export type AdminBobDaybookController_findAll = void;
  export type AdminBobVATController_findAll = void;
  export type AdminBobContactController_findAll = void;
  export type AdminBobContactController_create =
    Response$AdminBobContactController_create$Status$409;
  export type AdminBobContactController_suggestBobId = void;
  export type AdminProcessTemplateController_findAll = void;
  export type AdminProcessTemplateController_create = void;
  export type AdminProcessTemplateController_findOneById = void;
  export type AdminProcessTemplateController_delete = void;
  export type AdminProcessTemplateController_update = void;
  export type AdminProcessTemplateController_publish = void;
  export type AdminProcessTemplateController_unpublish = void;
  export type AdminStepController_findAll = void;
  export type AdminStepController_create =
    Response$AdminStepController_create$Status$400;
  export type AdminStepController_delete = void;
  export type AdminStepController_update = void;
  export type AdminPayslipDocumentController_findAll = void;
  export type AdminPayslipDocumentController_create = void;
  export type AdminPayslipDocumentController_findOneById = void;
  export type AdminPayslipDocumentController_delete = void;
  export type AdminPayslipDocumentController_updateOneById = void;
  export type AdminBillingDocumentController_findAllOneTimeInvoices = void;
  export type AdminBillingDocumentController_createOneTimeInvoice = void;
  export type AdminBillingDocumentController_createCreditNote = void;
  export type AdminBillingDocumentController_createCreditNoteV3 = void;
  export type AdminBillingDocumentController_getCreditNoteCapabilities = void;
  export type AdminBillingDocumentController_findOneById = void;
  export type AdminBillingDocumentController_delete = void;
  export type AdminBillingDocumentController_updateOneById = void;
  export type AdminBillingDocumentController_create = void;
  export type AdminCurrencyExchangeRateController_getRate = void;
  export type AdminPersonsController_findAll = void;
  export type AdminPersonsController_create = void;
  export type AdminPersonsController_findOne = void;
  export type AdminPersonsController_update = void;
  export type AdminPersonsController_remove = void;
  export type AdminPersonsController_assignUboNumber = void;
  export type AdminObligationController_findAll = void;
  export type AdminObligationController_create = void;
  export type AdminObligationController_findOneById = void;
  export type AdminObligationController_deleteOneById = void;
  export type AdminObligationController_updateOneById = void;
  export type AdminObligationController_findEventsById = void;
  export type NewsletterController_getRecipients = void;
  export type NewsletterController_sync =
    Response$NewsletterController_sync$Status$409;
  export type NewsletterController_syncStatus = void;
  export type NewsletterController_getCampaigns = void;
  export type NewsletterController_getStats = void;
}
export interface Encoding {
  readonly contentType?: string;
  headers?: Record<string, any>;
  readonly style?: 'form' | 'spaceDelimited' | 'pipeDelimited' | 'deepObject';
  readonly explode?: boolean;
  readonly allowReserved?: boolean;
}
export interface RequestArgs {
  readonly httpMethod: HttpMethod;
  readonly url: string;
  headers: ObjectLike | any;
  requestBody?: ObjectLike | any;
  requestBodyEncoding?: Record<string, Encoding>;
  queryParameters?: QueryParameters | undefined;
}
export interface ApiClient<RequestOption> {
  request: <T = SuccessResponses>(
    requestArgs: RequestArgs,
    options?: RequestOption
  ) => Promise<T>;
}
export const createClient = <RequestOption,>(
  apiClient: ApiClient<RequestOption>,
  baseUrl: string
) => {
  const _baseUrl = baseUrl.replace(/\/$/, '');
  return {
    /**
     * Login user
     * Login user
     * operationId: AdminAuthController_login
     * Request URI: /api/admin/auth/login
     */
    AdminAuthController_login: (
      params: Params$AdminAuthController_login,
      option?: RequestOption
    ): Promise<
      Response$AdminAuthController_login$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/auth/login`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'PUT',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a list of users
     * Get a list of users
     * operationId: AdminUserController_getUsers
     * Request URI: /api/admin/users
     */
    AdminUserController_getUsers: (
      params: Params$AdminUserController_getUsers,
      option?: RequestOption
    ): Promise<
      Response$AdminUserController_getUsers$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/users`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        includeBlocked: {
          value: params.parameter.includeBlocked,
          explode: false,
        },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Update user
     * Update user
     * operationId: AdminUserController_updateCurrentUser
     * Request URI: /api/admin/users/{id}
     */
    AdminUserController_updateCurrentUser: (
      params: Params$AdminUserController_updateCurrentUser,
      option?: RequestOption
    ): Promise<
      Response$AdminUserController_updateCurrentUser$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/users/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Block a user
     * Block a user, revoking their access here and in the identity provider
     * operationId: AdminUserController_blockUser
     * Request URI: /api/admin/users/{id}/block
     */
    AdminUserController_blockUser: (
      params: Params$AdminUserController_blockUser,
      option?: RequestOption
    ): Promise<
      Response$AdminUserController_blockUser$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/users/${params.parameter.id}/block`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Unblock a user
     * Restore a blocked user
     * operationId: AdminUserController_unblockUser
     * Request URI: /api/admin/users/{id}/unblock
     */
    AdminUserController_unblockUser: (
      params: Params$AdminUserController_unblockUser,
      option?: RequestOption
    ): Promise<
      Response$AdminUserController_unblockUser$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/users/${params.parameter.id}/unblock`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of users
     * Get a list of users
     * operationId: AdminUserController_getCurrentUser
     * Request URI: /api/admin/users/me
     */
    AdminUserController_getCurrentUser: (
      option?: RequestOption
    ): Promise<
      Response$AdminUserController_getCurrentUser$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/users/me`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of companies
     * Get a list of companies
     * operationId: AdminCompanyController_findAll
     * Request URI: /api/admin/companies
     */
    AdminCompanyController_findAll: (
      params: Params$AdminCompanyController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/companies`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        perPage: { value: params.parameter.perPage, explode: false },
        term: { value: params.parameter.term, explode: false },
        status: { value: params.parameter.status, explode: false },
        countryCode: { value: params.parameter.countryCode, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get all available promo codes
     * Get all available promo codes
     * operationId: AdminCompanyController_getAllPromoCodes
     * Request URI: /api/admin/companies/promo_codes
     */
    AdminCompanyController_getAllPromoCodes: (
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyController_getAllPromoCodes$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/companies/promo_codes`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * List company memberships
     * List company memberships — per-company Team roster (with companyId) or the bulk cross-company access map
     * operationId: AdminCompanyController_listMemberships
     * Request URI: /api/admin/companies/memberships
     */
    AdminCompanyController_listMemberships: (
      params: Params$AdminCompanyController_listMemberships,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyController_listMemberships$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/companies/memberships`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        perPage: { value: params.parameter.perPage, explode: false },
        companyId: { value: params.parameter.companyId, explode: false },
        userId: { value: params.parameter.userId, explode: false },
        role: { value: params.parameter.role, explode: false },
        term: { value: params.parameter.term, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get a company by its id
     * Get a company by its id
     * operationId: AdminCompanyController_findOneById
     * Request URI: /api/admin/companies/{id}
     */
    AdminCompanyController_findOneById: (
      params: Params$AdminCompanyController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyController_findOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/companies/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a company by its ID
     * Update a company by its ID
     * operationId: AdminCompanyController_updateOneById
     * Request URI: /api/admin/companies/{id}
     */
    AdminCompanyController_updateOneById: (
      params: Params$AdminCompanyController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyController_updateOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/companies/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Add a user to a company
     * Add a user to a company with the given access rights
     * operationId: AdminCompanyController_addUser
     * Request URI: /api/admin/companies/{id}/users
     */
    AdminCompanyController_addUser: (
      params: Params$AdminCompanyController_addUser,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyController_addUser$Status$201['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/companies/${params.parameter.id}/users`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Remove a user from a company
     * Remove a user from a company (the last member cannot be removed)
     * operationId: AdminCompanyController_removeUser
     * Request URI: /api/admin/companies/{id}/users/{userId}
     */
    AdminCompanyController_removeUser: (
      params: Params$AdminCompanyController_removeUser,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyController_removeUser$Status$200['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/companies/${params.parameter.id}/users/${params.parameter.userId}`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Create a new file
     * Create a new file
     * operationId: AdminObligationFileController_create
     * Request URI: /api/admin/obligations/files
     */
    AdminObligationFileController_create: (
      params: Params$AdminObligationFileController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationFileController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/obligations/files`;
      const headers = {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Remove a file by its id
     * Remove a file by its id
     * operationId: AdminObligationFileController_delete
     * Request URI: /api/admin/obligations/files/{id}
     */
    AdminObligationFileController_delete: (
      params: Params$AdminObligationFileController_delete,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationFileController_delete$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/obligations/files/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a file by its ID
     * Update a file by its ID
     * operationId: AdminObligationFileController_updateOneById
     * Request URI: /api/admin/obligations/files/{id}
     */
    AdminObligationFileController_updateOneById: (
      params: Params$AdminObligationFileController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationFileController_updateOneById$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/obligations/files/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a list of transactions
     * Get a list of transactions
     * operationId: AdminTransactionController_findAll
     * Request URI: /api/admin/transactions
     */
    AdminTransactionController_findAll: (
      params: Params$AdminTransactionController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminTransactionController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/transactions`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        dateFrom: { value: params.parameter.dateFrom, explode: false },
        dateTo: { value: params.parameter.dateTo, explode: false },
        term: { value: params.parameter.term, explode: false },
        accountId: { value: params.parameter.accountId, explode: false },
        adminStatus: { value: params.parameter.adminStatus, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get a list of transactions in excel format
     * Get a list of transactions in excel format
     * operationId: AdminTransactionController_toExcel
     * Request URI: /api/admin/transactions/excel
     */
    AdminTransactionController_toExcel: (
      params: Params$AdminTransactionController_toExcel,
      option?: RequestOption
    ): Promise<
      Response$AdminTransactionController_toExcel$Status$200['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    > => {
      const url = _baseUrl + `/api/admin/transactions/excel`;
      const headers = {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        dateFrom: { value: params.parameter.dateFrom, explode: false },
        dateTo: { value: params.parameter.dateTo, explode: false },
        term: { value: params.parameter.term, explode: false },
        accountId: { value: params.parameter.accountId, explode: false },
        adminStatus: { value: params.parameter.adminStatus, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get a transaction by its id
     * Get a transaction by its id
     * operationId: AdminTransactionController_findOneById
     * Request URI: /api/admin/transactions/{id}
     */
    AdminTransactionController_findOneById: (
      params: Params$AdminTransactionController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminTransactionController_findOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/transactions/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a transaction by its ID
     * Update a transaction by its ID
     * operationId: AdminTransactionController_updateOneById
     * Request URI: /api/admin/transactions/{id}
     */
    AdminTransactionController_updateOneById: (
      params: Params$AdminTransactionController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminTransactionController_updateOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/transactions/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a list of uploaded transaction batches
     * Get a list of uploaded transaction batches (ingests), newest upload first
     * operationId: AdminTransactionIngestController_findAll
     * Request URI: /api/admin/transaction-ingests
     */
    AdminTransactionIngestController_findAll: (
      params: Params$AdminTransactionIngestController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminTransactionIngestController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/transaction-ingests`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        includeEmpty: { value: params.parameter.includeEmpty, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get the transactions of a batch
     * Get the transactions a batch brought in, oldest booking date first. Use this to preview a batch that has no source file to download — integration batches never have one.
     * operationId: AdminTransactionIngestController_findRows
     * Request URI: /api/admin/transaction-ingests/{id}/transactions
     */
    AdminTransactionIngestController_findRows: (
      params: Params$AdminTransactionIngestController_findRows,
      option?: RequestOption
    ): Promise<
      Response$AdminTransactionIngestController_findRows$Status$200['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/transaction-ingests/${params.parameter.id}/transactions`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of documents
     * Get a list of documents
     * operationId: AdminDocumentController_findAll
     * Request URI: /api/admin/documents
     */
    AdminDocumentController_findAll: (
      params: Params$AdminDocumentController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminDocumentController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/documents`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        perPage: { value: params.parameter.perPage, explode: false },
        page: { value: params.parameter.page, explode: false },
        type: { value: params.parameter.type, explode: false },
        term: { value: params.parameter.term, explode: false },
        name: { value: params.parameter.name, explode: false },
        contactName: { value: params.parameter.contactName, explode: false },
        referenceId: { value: params.parameter.referenceId, explode: false },
        invoiceNumber: {
          value: params.parameter.invoiceNumber,
          explode: false,
        },
        adminStatus: { value: params.parameter.adminStatus, explode: false },
        dateFrom: { value: params.parameter.dateFrom, explode: false },
        dateTo: { value: params.parameter.dateTo, explode: false },
        filterDateBy: { value: params.parameter.filterDateBy, explode: false },
        sortBy: { value: params.parameter.sortBy, explode: false },
        status: { value: params.parameter.status, explode: false },
        ignoreDrafts: { value: params.parameter.ignoreDrafts, explode: false },
        withErrors: { value: params.parameter.withErrors, explode: false },
        blankIssueDate: {
          value: params.parameter.blankIssueDate,
          explode: false,
        },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get a list of documents
     * Get a list of documents
     * operationId: AdminDocumentController_bulkDownload
     * Request URI: /api/admin/documents/bulk_download
     */
    AdminDocumentController_bulkDownload: (
      params: Params$AdminDocumentController_bulkDownload,
      option?: RequestOption
    ): Promise<void> => {
      const url = _baseUrl + `/api/admin/documents/bulk_download`;
      const headers = {
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        perPage: { value: params.parameter.perPage, explode: false },
        page: { value: params.parameter.page, explode: false },
        type: { value: params.parameter.type, explode: false },
        term: { value: params.parameter.term, explode: false },
        name: { value: params.parameter.name, explode: false },
        contactName: { value: params.parameter.contactName, explode: false },
        referenceId: { value: params.parameter.referenceId, explode: false },
        invoiceNumber: {
          value: params.parameter.invoiceNumber,
          explode: false,
        },
        adminStatus: { value: params.parameter.adminStatus, explode: false },
        dateFrom: { value: params.parameter.dateFrom, explode: false },
        dateTo: { value: params.parameter.dateTo, explode: false },
        filterDateBy: { value: params.parameter.filterDateBy, explode: false },
        sortBy: { value: params.parameter.sortBy, explode: false },
        status: { value: params.parameter.status, explode: false },
        ignoreDrafts: { value: params.parameter.ignoreDrafts, explode: false },
        withErrors: { value: params.parameter.withErrors, explode: false },
        blankIssueDate: {
          value: params.parameter.blankIssueDate,
          explode: false,
        },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get the last params for a contact
     * Get the last params for a contact
     * operationId: AdminDocumentController_findLastParamsForContact
     * Request URI: /api/admin/documents/last-params/{contactId}
     */
    AdminDocumentController_findLastParamsForContact: (
      params: Params$AdminDocumentController_findLastParamsForContact,
      option?: RequestOption
    ): Promise<
      Response$AdminDocumentController_findLastParamsForContact$Status$200['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/documents/last-params/${params.parameter.contactId}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a document by its id
     * Get a document by its id
     * operationId: AdminDocumentController_findOneById
     * Request URI: /api/admin/documents/{id}
     */
    AdminDocumentController_findOneById: (
      params: Params$AdminDocumentController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminDocumentController_findOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/documents/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a document by its ID
     * Update a document by its ID
     * operationId: AdminDocumentController_updateOneById
     * Request URI: /api/admin/documents/{id}
     */
    AdminDocumentController_updateOneById: (
      params: Params$AdminDocumentController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminDocumentController_updateOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/documents/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Update a documents by its ID
     * Update a documents by its ID
     * operationId: AdminDocumentController_bulkUpdate
     * Request URI: /api/admin/documents/bulk_update
     */
    AdminDocumentController_bulkUpdate: (
      params: Params$AdminDocumentController_bulkUpdate,
      option?: RequestOption
    ): Promise<void> => {
      const url = _baseUrl + `/api/admin/documents/bulk_update`;
      const headers = {
        'Content-Type': 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Retry the BOB sync of a document by its ID
     * Give a document another attempt at BOB: clears any error flag, returns it to the processing/pending queue and restarts the stuck-watchdog clock, in one transaction. Refused for a document that already carries a booking id.
     * operationId: AdminDocumentController_retryBobSync
     * Request URI: /api/admin/documents/{id}/bob_retry
     */
    AdminDocumentController_retryBobSync: (
      params: Params$AdminDocumentController_retryBobSync,
      option?: RequestOption
    ): Promise<
      Response$AdminDocumentController_retryBobSync$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/documents/${params.parameter.id}/bob_retry`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Run recognition on a document by its ID
     * Run recognition on a document by its ID
     * operationId: AdminDocumentController_runRecognition
     * Request URI: /api/admin/documents/{id}/run_recognition
     */
    AdminDocumentController_runRecognition: (
      params: Params$AdminDocumentController_runRecognition,
      option?: RequestOption
    ): Promise<void> => {
      const url =
        _baseUrl +
        `/api/admin/documents/${params.parameter.id}/run_recognition`;
      const headers = {
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
        },
        option
      );
    },
    /**
     * List all company accounts
     * Get accounts
     * operationId: AdminAccountsController_getAccounts
     * Request URI: /api/admin/accounts
     */
    AdminAccountsController_getAccounts: (
      params: Params$AdminAccountsController_getAccounts,
      option?: RequestOption
    ): Promise<
      Response$AdminAccountsController_getAccounts$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/accounts`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Sync account
     * Sync account
     * operationId: AdminAccountsController_syncConnection
     * Request URI: /api/admin/accounts/{id}/sync
     */
    AdminAccountsController_syncConnection: (
      params: Params$AdminAccountsController_syncConnection,
      option?: RequestOption
    ): Promise<void> => {
      const url = _baseUrl + `/api/admin/accounts/${params.parameter.id}/sync`;
      const headers = {
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
        },
        option
      );
    },
    /**
     * List accounts with an open balance discrepancy, across every company in scope
     * Reconciles every bank-connected account in the estate against its imported transactions, interval by interval, and returns the ones that do not add up — oldest discrepancy first, with the interval it started in and whether it looks like a booking-date shift or a missing transaction. `windowDays` sets how far back to walk; every row also carries how far out its opening balance already was, since that part the walk assumes rather than checks. Counts are as mirrored into `public`, which is best-effort by design.
     * operationId: AdminBalancePortfolioController_findDiscrepancies
     * Request URI: /api/admin/balance_portfolio
     */
    AdminBalancePortfolioController_findDiscrepancies: (
      params: Params$AdminBalancePortfolioController_findDiscrepancies,
      option?: RequestOption
    ): Promise<
      Response$AdminBalancePortfolioController_findDiscrepancies$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/balance_portfolio`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        windowDays: { value: params.parameter.windowDays, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Accounting plan usage of every company in one calendar year
     * One row per company, whatever its status or plan. For the current year the plan is the current one; for a past year it is the plan that was in force when that year ended.
     * operationId: AdminAccountingUsageController_list
     * Request URI: /api/admin/accounting_usage
     */
    AdminAccountingUsageController_list: (
      params: Params$AdminAccountingUsageController_list,
      option?: RequestOption
    ): Promise<
      Response$AdminAccountingUsageController_list$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/accounting_usage`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        year: { value: params.parameter.year, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * A company's current accounting plan and every change made to it
     * operationId: AdminAccountingUsageController_getPlan
     * Request URI: /api/admin/accounting_usage/plans/{companyId}
     */
    AdminAccountingUsageController_getPlan: (
      params: Params$AdminAccountingUsageController_getPlan,
      option?: RequestOption
    ): Promise<
      Response$AdminAccountingUsageController_getPlan$Status$200['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/accounting_usage/plans/${params.parameter.companyId}`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Set a company's accounting plan
     * The plan type only moves towards `documents`: a legacy turnover plan cannot be given to a company that is not already on one (400 `plan_type_change_not_allowed`). Saving the plan a company already has writes nothing.
     * operationId: AdminAccountingUsageController_updatePlan
     * Request URI: /api/admin/accounting_usage/plans/{companyId}
     */
    AdminAccountingUsageController_updatePlan: (
      params: Params$AdminAccountingUsageController_updatePlan,
      option?: RequestOption
    ): Promise<
      Response$AdminAccountingUsageController_updatePlan$Status$200['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/accounting_usage/plans/${params.parameter.companyId}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'PUT',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * List companies MDS is still incorporating
     * Read live from Master Data with the caller's own token, annotated with what legacy already holds.
     * operationId: AdminMdsIncorporationsController_list
     * Request URI: /api/admin/mds_incorporations
     */
    AdminMdsIncorporationsController_list: (
      params: Params$AdminMdsIncorporationsController_list,
      option?: RequestOption
    ): Promise<
      Response$AdminMdsIncorporationsController_list$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/mds_incorporations`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        search: { value: params.parameter.search, explode: false },
        provisioned: { value: params.parameter.provisioned, explode: false },
        changedOnly: { value: params.parameter.changedOnly, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * One MDS company, with the people who can hold its portal account
     * The owner is already chosen; `ownerSelectionReason` says on what evidence.
     * operationId: AdminMdsIncorporationsController_details
     * Request URI: /api/admin/mds_incorporations/{mdsCompanyId}
     */
    AdminMdsIncorporationsController_details: (
      params: Params$AdminMdsIncorporationsController_details,
      option?: RequestOption
    ): Promise<
      Response$AdminMdsIncorporationsController_details$Status$200['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/mds_incorporations/${params.parameter.mdsCompanyId}`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Provision the company in legacy and move MDS to in_service
     * Creates the company, its tenant schema and a portal account per linked person, then patches MDS. Idempotent: pressing it again finishes whatever an earlier attempt did not, and never builds a second tenant — a company already in legacy is adopted, not duplicated, and the first adoption records this MDS id against it so the retry is admitted. A failure of the MDS half alone is reported as `mdsUpdated: false`, not as an error: the legacy side stands.
     * operationId: AdminMdsIncorporationsController_provision
     * Request URI: /api/admin/mds_incorporations/{mdsCompanyId}/provision
     */
    AdminMdsIncorporationsController_provision: (
      params: Params$AdminMdsIncorporationsController_provision,
      option?: RequestOption
    ): Promise<
      Response$AdminMdsIncorporationsController_provision$Status$201['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/mds_incorporations/${params.parameter.mdsCompanyId}/provision`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Retry only the MDS status change
     * For the desync case: legacy has the company, MDS still says incorporating. Touches nothing in legacy.
     * operationId: AdminMdsIncorporationsController_syncMdsStatus
     * Request URI: /api/admin/mds_incorporations/{mdsCompanyId}/mds_status
     */
    AdminMdsIncorporationsController_syncMdsStatus: (
      params: Params$AdminMdsIncorporationsController_syncMdsStatus,
      option?: RequestOption
    ): Promise<
      Response$AdminMdsIncorporationsController_syncMdsStatus$Status$201['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/mds_incorporations/${params.parameter.mdsCompanyId}/mds_status`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Re-read this company from MDS and fill legacy again
     * The same fill provisioning runs, on its own. It exists because the facts legal-docs prints arrive after the button: a company is provisioned the day it is incorporated, and its RCS number and RCS extract reach MDS days later. Additive — it inserts what legacy is missing, refreshes only the rows this pipeline wrote, and never deletes a participant. The owner becomes the contact person unless `updateContactPerson` is false. Only companies provisioned from this page are accepted.
     * operationId: AdminMdsIncorporationsController_refreshFromMds
     * Request URI: /api/admin/mds_incorporations/{mdsCompanyId}/refresh
     */
    AdminMdsIncorporationsController_refreshFromMds: (
      params: Params$AdminMdsIncorporationsController_refreshFromMds,
      option?: RequestOption
    ): Promise<
      Response$AdminMdsIncorporationsController_refreshFromMds$Status$201['application/json']
    > => {
      const url =
        _baseUrl +
        `/api/admin/mds_incorporations/${params.parameter.mdsCompanyId}/refresh`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a list of events
     * Get a list of events
     * operationId: AdminEventController_findAll
     * Request URI: /api/admin/events
     */
    AdminEventController_findAll: (
      params: Params$AdminEventController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminEventController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/events`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        entityType: { value: params.parameter.entityType, explode: false },
        entityId: { value: params.parameter.entityId, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get the membership audit journal
     * Company membership audit journal (access granted / revoked / permissions changed)
     * operationId: AdminEventController_findMembershipJournal
     * Request URI: /api/admin/events/memberships
     */
    AdminEventController_findMembershipJournal: (
      params: Params$AdminEventController_findMembershipJournal,
      option?: RequestOption
    ): Promise<
      Response$AdminEventController_findMembershipJournal$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/events/memberships`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        perPage: { value: params.parameter.perPage, explode: false },
        entityId: { value: params.parameter.entityId, explode: false },
        type: { value: params.parameter.type, explode: false },
        dateFrom: { value: params.parameter.dateFrom, explode: false },
        dateTo: { value: params.parameter.dateTo, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * The company being exported
     * Company basics including the BOB reference id, for the tenant named by the companyId header — the same header every other route here takes. The id comes from the company list the consumer pulls first; this route deliberately does no lookup of its own.
     * operationId: AdminExportController_describeCompany
     * Request URI: /api/admin/export/v1/company
     */
    AdminExportController_describeCompany: (
      params: Params$AdminExportController_describeCompany,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_describeCompany$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/company`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * List the BOB contacts of the tenant
     * Only bob_contacts — the tenant's own contacts table carries no BOB id and is out of scope for this export. That is why contactId on documents and transactions has no matching record here. Pass includeRawBobData to get the whole ac_compan row BOB50 holds for each contact, which is every field this record's typed columns do not cover.
     * operationId: AdminExportController_listContacts
     * Request URI: /api/admin/export/v1/contacts
     */
    AdminExportController_listContacts: (
      params: Params$AdminExportController_listContacts,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listContacts$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/contacts`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
        includeRawBobData: {
          value: params.parameter.includeRawBobData,
          explode: false,
        },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * List the BOB50 chart of accounts of the tenant
     * The account numbers and headings the BOB50 automator reports for the dossier — what accountCode on a document's line items refers to. Not the bank accounts, which are /v1/accounts. Rows are only ever added or renamed, never removed, so an account deleted in BOB50 is still listed. Empty for a company with no BOB50 dossier.
     * operationId: AdminExportController_listBobAccounts
     * Request URI: /api/admin/export/v1/bob-accounts
     */
    AdminExportController_listBobAccounts: (
      params: Params$AdminExportController_listBobAccounts,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listBobAccounts$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/bob-accounts`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * List the BOB50 daybooks of the tenant
     * Every BOB50 journal the automator reports for the dossier — code, heading and journal type. The code is what daybookId on a document's bookkeeping metadata refers to. Rows are only ever added or updated, never removed, so a journal deleted in BOB50 is still listed. Empty for a company with no BOB50 dossier.
     * operationId: AdminExportController_listBobDaybooks
     * Request URI: /api/admin/export/v1/bob-daybooks
     */
    AdminExportController_listBobDaybooks: (
      params: Params$AdminExportController_listBobDaybooks,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listBobDaybooks$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/bob-daybooks`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * List the bank accounts of the tenant
     * Includes archived accounts and the provider-side externalId. accountNumber carries the IBAN the provider returned, and bankName/bankBic the bank behind the connection — both null for an account with no connection.
     * operationId: AdminExportController_listAccounts
     * Request URI: /api/admin/export/v1/accounts
     */
    AdminExportController_listAccounts: (
      params: Params$AdminExportController_listAccounts,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listAccounts$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/accounts`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * List the documents (invoices) of the tenant
     * Includes archived documents. Carries a pre-signed downloadUrl for the original file alongside its permanent S3 coordinates, both issue-date fields with their recognition provenance, and the BOB booking state used for reconciliation. Fetch the bytes from S3 with downloadUrl — this API never serves file content. A document the client typed rather than uploaded has no file: fileName and every S3 field are null on it, so there is nothing to fetch — mimeType goes out as the column holds it, see the DTO. Set includeRecognitionData=true to add the raw OCR prediction to each record; it is the largest field here by a wide margin, so pair it with a smaller limit.
     * operationId: AdminExportController_listDocuments
     * Request URI: /api/admin/export/v1/documents
     */
    AdminExportController_listDocuments: (
      params: Params$AdminExportController_listDocuments,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listDocuments$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/documents`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
        urlExpiresIn: { value: params.parameter.urlExpiresIn, explode: false },
        includeRecognitionData: {
          value: params.parameter.includeRecognitionData,
          explode: false,
        },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * List the EasyBiz billing documents issued to the tenant
     * Our billing of the company, not the company's own bookkeeping: every invoice and credit note EasyBiz issued to this tenant, with a pre-signed downloadUrl for the PDF served under its document number. Amounts are gross and come in both major and internal units; the billed period is carried inline, the service lines come in serviceLines — from the billed period for every invoice issued before the writers began snapshotting them into the document, which serviceLinesFromBillingPeriod reports — and the full document_metadata goes out beside the typed fields, its items[] carrying those same lines so a consumer reading them from there keeps working. No payment status: the product resolves that against EasyBiz's own tenant, which this contract does not read.
     * operationId: AdminExportController_listBillingDocuments
     * Request URI: /api/admin/export/v1/billing-documents
     */
    AdminExportController_listBillingDocuments: (
      params: Params$AdminExportController_listBillingDocuments,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listBillingDocuments$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/billing-documents`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
        urlExpiresIn: { value: params.parameter.urlExpiresIn, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * List the transaction import batches of the tenant
     * Returns the CSV mapping alongside each batch: a csv transaction's rawIngestData is a positional array of cells and cannot be interpreted without it. A batch that uploaded a CSV also carries a pre-signed downloadUrl for it.
     * operationId: AdminExportController_listTransactionIngests
     * Request URI: /api/admin/export/v1/transaction-ingests
     */
    AdminExportController_listTransactionIngests: (
      params: Params$AdminExportController_listTransactionIngests,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listTransactionIngests$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/transaction-ingests`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
        urlExpiresIn: { value: params.parameter.urlExpiresIn, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * List the transactions of the tenant
     * Every transaction including splits, with raw_ingest_data tagged by the format its ingest path produced.
     * operationId: AdminExportController_listTransactions
     * Request URI: /api/admin/export/v1/transactions
     */
    AdminExportController_listTransactions: (
      params: Params$AdminExportController_listTransactions,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listTransactions$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/transactions`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * List the transaction ↔ document attachments
     * The reconciliation link as plain pairs. Every other surface exposes it only as a per-transaction boolean.
     * operationId: AdminExportController_listTransactionDocuments
     * Request URI: /api/admin/export/v1/transaction-documents
     */
    AdminExportController_listTransactionDocuments: (
      params: Params$AdminExportController_listTransactionDocuments,
      option?: RequestOption
    ): Promise<
      Response$AdminExportController_listTransactionDocuments$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/export/v1/transaction-documents`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        cursor: { value: params.parameter.cursor, explode: false },
        limit: { value: params.parameter.limit, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get a incorporation
     * Get a incorporation
     * operationId: AdminIncorporationController_findOneById
     * Request URI: /api/admin/incorporations
     */
    AdminIncorporationController_findOneById: (
      params: Params$AdminIncorporationController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminIncorporationController_findOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/incorporations`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a incorporation
     * Update a incorporation
     * operationId: AdminIncorporationController_updateOneById
     * Request URI: /api/admin/incorporations
     */
    AdminIncorporationController_updateOneById: (
      params: Params$AdminIncorporationController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminIncorporationController_updateOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/incorporations`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Update incorporation kyc
     * Approve incorporation kyc
     * operationId: AdminIncorporationController_approveKyc
     * Request URI: /api/admin/incorporations/approve
     */
    AdminIncorporationController_approveKyc: (
      params: Params$AdminIncorporationController_approveKyc,
      option?: RequestOption
    ): Promise<
      Response$AdminIncorporationController_approveKyc$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/incorporations/approve`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Fail incorporation kyc
     * Fail incorporation kyc
     * operationId: AdminIncorporationController_failKyc
     * Request URI: /api/admin/incorporations/fail
     */
    AdminIncorporationController_failKyc: (
      params: Params$AdminIncorporationController_failKyc,
      option?: RequestOption
    ): Promise<
      Response$AdminIncorporationController_failKyc$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/incorporations/fail`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of files
     * Get a list of files
     * operationId: AdminCompanyFileController_findAll
     * Request URI: /api/admin/company_files
     */
    AdminCompanyFileController_findAll: (
      params: Params$AdminCompanyFileController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyFileController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/company_files`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        type: { value: params.parameter.type, explode: false },
        personId: { value: params.parameter.personId, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Create a new file
     * Create a new file
     * operationId: AdminCompanyFileController_create
     * Request URI: /api/admin/company_files
     */
    AdminCompanyFileController_create: (
      params: Params$AdminCompanyFileController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyFileController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/company_files`;
      const headers = {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Save a chat file to corporate documents
     * Save a chat task file into the company Corporate Documents (type = legal)
     * operationId: AdminCompanyFileController_createFromTaskFile
     * Request URI: /api/admin/company_files/from-task-file
     */
    AdminCompanyFileController_createFromTaskFile: (
      params: Params$AdminCompanyFileController_createFromTaskFile,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyFileController_createFromTaskFile$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/company_files/from-task-file`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Remove a file by its id
     * Remove a file by its id
     * operationId: AdminCompanyFileController_delete
     * Request URI: /api/admin/company_files/{id}
     */
    AdminCompanyFileController_delete: (
      params: Params$AdminCompanyFileController_delete,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyFileController_delete$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/company_files/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a file by its ID
     * Update a file by its ID
     * operationId: AdminCompanyFileController_updateOneById
     * Request URI: /api/admin/company_files/{id}
     */
    AdminCompanyFileController_updateOneById: (
      params: Params$AdminCompanyFileController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminCompanyFileController_updateOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/company_files/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get Onfido verification data for a person
     * Get Onfido verification data for a person
     * operationId: AdminOnfidoDataController_create
     * Request URI: /api/admin/onfido_datas
     */
    AdminOnfidoDataController_create: (
      params: Params$AdminOnfidoDataController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminOnfidoDataController_create$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/onfido_datas`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        personId: { value: params.parameter.personId, explode: false },
        companyId: { value: params.parameter.companyId, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Generate a verification link for a person (or get unfinished one)
     * Generate a verification link for a person
     * operationId: AdminOnfidoDataController_generateLink
     * Request URI: /api/admin/onfido_datas
     */
    AdminOnfidoDataController_generateLink: (
      params: Params$AdminOnfidoDataController_generateLink,
      option?: RequestOption
    ): Promise<
      (
        | Response$AdminOnfidoDataController_generateLink$Status$200
        | Response$AdminOnfidoDataController_generateLink$Status$201
      )['application/json']
    > => {
      const url = _baseUrl + `/api/admin/onfido_datas`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        personId: { value: params.parameter.personId, explode: false },
        companyId: { value: params.parameter.companyId, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get the Sumsub verification data of a person
     * The person's Sumsub applicant row, or null when no link has been minted yet
     * operationId: AdminSumsubDataController_findForPerson
     * Request URI: /api/admin/sumsub_datas
     */
    AdminSumsubDataController_findForPerson: (
      params: Params$AdminSumsubDataController_findForPerson,
      option?: RequestOption
    ): Promise<
      Response$AdminSumsubDataController_findForPerson$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/sumsub_datas`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        personId: { value: params.parameter.personId, explode: false },
        companyId: { value: params.parameter.companyId, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Generate a Sumsub verification link for a person
     * Mint a Sumsub verification link for a person, reusing the existing applicant. Only for companies on incorporation version 3+ — earlier ones verify through Onfido.
     * operationId: AdminSumsubDataController_generateLink
     * Request URI: /api/admin/sumsub_datas
     */
    AdminSumsubDataController_generateLink: (
      params: Params$AdminSumsubDataController_generateLink,
      option?: RequestOption
    ): Promise<
      (
        | Response$AdminSumsubDataController_generateLink$Status$200
        | Response$AdminSumsubDataController_generateLink$Status$201
      )['application/json']
    > => {
      const url = _baseUrl + `/api/admin/sumsub_datas`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        personId: { value: params.parameter.personId, explode: false },
        companyId: { value: params.parameter.companyId, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get a list of tasks
     * Get a list of tasks
     * operationId: AdminTaskController_findAll
     * Request URI: /api/admin/tasks
     */
    AdminTaskController_findAll: (
      params: Params$AdminTaskController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminTaskController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/tasks`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        topic: { value: params.parameter.topic, explode: false },
        companyId: { value: params.parameter.companyId, explode: false },
        onlyForUser: { value: params.parameter.onlyForUser, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Create a new task
     * Create a new task
     * operationId: AdminTaskController_create
     * Request URI: /api/admin/tasks
     */
    AdminTaskController_create: (
      params: Params$AdminTaskController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminTaskController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/tasks`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Create a new task idempotently
     * Create a new task idempotently
     * operationId: AdminTaskController_createV2
     * Request URI: /api/admin/tasks/v2
     */
    AdminTaskController_createV2: (
      params: Params$AdminTaskController_createV2,
      option?: RequestOption
    ): Promise<
      Response$AdminTaskController_createV2$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/tasks/v2`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Update a task by id
     * Update a task by id
     * operationId: AdminTaskController_updateOneById
     * Request URI: /api/admin/tasks/{id}
     */
    AdminTaskController_updateOneById: (
      params: Params$AdminTaskController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminTaskController_updateOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/tasks/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Close a task by id
     * Close a task by id
     * operationId: AdminTaskController_close
     * Request URI: /api/admin/tasks/{id}/close
     */
    AdminTaskController_close: (
      params: Params$AdminTaskController_close,
      option?: RequestOption
    ): Promise<
      Response$AdminTaskController_close$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/tasks/${params.parameter.id}/close`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Create a new taskFile
     * Create a new taskFile
     * operationId: AdminTaskFileController_create
     * Request URI: /api/admin/task_files
     */
    AdminTaskFileController_create: (
      params: Params$AdminTaskFileController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminTaskFileController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/task_files`;
      const headers = {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a list of billing_periods that are not approved, across all billable companies
     * operationId: AdminBillingPeriodController_findAllUnapproved
     * Request URI: /api/admin/billing_periods/unapproved
     */
    AdminBillingPeriodController_findAllUnapproved: (
      option?: RequestOption
    ): Promise<
      Response$AdminBillingPeriodController_findAllUnapproved$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/billing_periods/unapproved`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of billing_periods
     * Get a list of billing_periods
     * operationId: AdminBillingPeriodController_findAll
     * Request URI: /api/admin/billing_periods
     */
    AdminBillingPeriodController_findAll: (
      params: Params$AdminBillingPeriodController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingPeriodController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/billing_periods`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Create a new billing_period
     * Create a new billing_period
     * operationId: AdminBillingPeriodController_create
     * Request URI: /api/admin/billing_periods
     */
    AdminBillingPeriodController_create: (
      params: Params$AdminBillingPeriodController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingPeriodController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/billing_periods`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a billing_period by its id
     * Get a billing_period by its id
     * operationId: AdminBillingPeriodController_findOneById
     * Request URI: /api/admin/billing_periods/{id}
     */
    AdminBillingPeriodController_findOneById: (
      params: Params$AdminBillingPeriodController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingPeriodController_findOneById$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/billing_periods/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Remove a billing_period by its id
     * Remove a billing_period by its id
     * operationId: AdminBillingPeriodController_delete
     * Request URI: /api/admin/billing_periods/{id}
     */
    AdminBillingPeriodController_delete: (
      params: Params$AdminBillingPeriodController_delete,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingPeriodController_delete$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/billing_periods/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a billing_period by its ID
     * Update a billing_period by its ID
     * operationId: AdminBillingPeriodController_updateOneById
     * Request URI: /api/admin/billing_periods/{id}
     */
    AdminBillingPeriodController_updateOneById: (
      params: Params$AdminBillingPeriodController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingPeriodController_updateOneById$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/billing_periods/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Approve a billing_period by its id
     * operationId: AdminBillingPeriodController_approve
     * Request URI: /api/admin/billing_periods/{id}/approve
     */
    AdminBillingPeriodController_approve: (
      params: Params$AdminBillingPeriodController_approve,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingPeriodController_approve$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/billing_periods/${params.parameter.id}/approve`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of bob accounts
     * Get a list of bob accounts
     * operationId: AdminBobAccountController_findAll
     * Request URI: /api/admin/bob/accounts
     */
    AdminBobAccountController_findAll: (
      params: Params$AdminBobAccountController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminBobAccountController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/bob/accounts`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        term: { value: params.parameter.term, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get a list of bob daybooks
     * Get a list of bob daybooks
     * operationId: AdminBobDaybookController_findAll
     * Request URI: /api/admin/bob/daybooks
     */
    AdminBobDaybookController_findAll: (
      params: Params$AdminBobDaybookController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminBobDaybookController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/bob/daybooks`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of bob VATs
     * Get a list of bob VATs
     * operationId: AdminBobVATController_findAll
     * Request URI: /api/admin/bob/vats
     */
    AdminBobVATController_findAll: (
      params: Params$AdminBobVATController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminBobVATController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/bob/vats`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of bob Contacts
     * Get a list of bob Contacts
     * operationId: AdminBobContactController_findAll
     * Request URI: /api/admin/bob/contacts
     */
    AdminBobContactController_findAll: (
      params: Params$AdminBobContactController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminBobContactController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/bob/contacts`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        term: { value: params.parameter.term, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Create a new bobContact
     * Create a new bobContact
     * operationId: AdminBobContactController_create
     * Request URI: /api/admin/bob/contacts
     */
    AdminBobContactController_create: (
      params: Params$AdminBobContactController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminBobContactController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/bob/contacts`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Suggest a BOB50 reference
     * Suggest a free, human-readable BOB50 reference for a contact name. Reserves nothing — uniqueness is decided when the contact is created.
     * operationId: AdminBobContactController_suggestBobId
     * Request URI: /api/admin/bob/contacts/suggest-bob-id
     */
    AdminBobContactController_suggestBobId: (
      params: Params$AdminBobContactController_suggestBobId,
      option?: RequestOption
    ): Promise<
      Response$AdminBobContactController_suggestBobId$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/bob/contacts/suggest-bob-id`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        name: { value: params.parameter.name, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get a list of process templates
     * Get a list of process templates
     * operationId: AdminProcessTemplateController_findAll
     * Request URI: /api/admin/process_templates
     */
    AdminProcessTemplateController_findAll: (
      params: Params$AdminProcessTemplateController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminProcessTemplateController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/process_templates`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        perPage: { value: params.parameter.perPage, explode: false },
        page: { value: params.parameter.page, explode: false },
        term: { value: params.parameter.term, explode: false },
        isPublished: { value: params.parameter.isPublished, explode: false },
        stepId: { value: params.parameter.stepId, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Create a new process template
     * operationId: AdminProcessTemplateController_create
     * Request URI: /api/admin/process_templates
     */
    AdminProcessTemplateController_create: (
      params: Params$AdminProcessTemplateController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminProcessTemplateController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/process_templates`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a process template by its id
     * Get a process template by its id
     * operationId: AdminProcessTemplateController_findOneById
     * Request URI: /api/admin/process_templates/{id}
     */
    AdminProcessTemplateController_findOneById: (
      params: Params$AdminProcessTemplateController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminProcessTemplateController_findOneById$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/process_templates/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Delete a process template
     * Delete a process template
     * operationId: AdminProcessTemplateController_delete
     * Request URI: /api/admin/process_templates/{id}
     */
    AdminProcessTemplateController_delete: (
      params: Params$AdminProcessTemplateController_delete,
      option?: RequestOption
    ): Promise<void> => {
      const url =
        _baseUrl + `/api/admin/process_templates/${params.parameter.id}`;
      const headers = {};
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a process template
     * operationId: AdminProcessTemplateController_update
     * Request URI: /api/admin/process_templates/{id}
     */
    AdminProcessTemplateController_update: (
      params: Params$AdminProcessTemplateController_update,
      option?: RequestOption
    ): Promise<
      Response$AdminProcessTemplateController_update$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/process_templates/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Publish a template
     * operationId: AdminProcessTemplateController_publish
     * Request URI: /api/admin/process_templates/{id}/publish
     */
    AdminProcessTemplateController_publish: (
      params: Params$AdminProcessTemplateController_publish,
      option?: RequestOption
    ): Promise<void> => {
      const url =
        _baseUrl +
        `/api/admin/process_templates/${params.parameter.id}/publish`;
      const headers = {};
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Unpublish a template
     * operationId: AdminProcessTemplateController_unpublish
     * Request URI: /api/admin/process_templates/{id}/unpublish
     */
    AdminProcessTemplateController_unpublish: (
      params: Params$AdminProcessTemplateController_unpublish,
      option?: RequestOption
    ): Promise<void> => {
      const url =
        _baseUrl +
        `/api/admin/process_templates/${params.parameter.id}/unpublish`;
      const headers = {};
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get all steps
     * operationId: AdminStepController_findAll
     * Request URI: /api/admin/steps
     */
    AdminStepController_findAll: (
      params: Params$AdminStepController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminStepController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/steps`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        term: { value: params.parameter.term, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Create a new step
     * operationId: AdminStepController_create
     * Request URI: /api/admin/steps
     */
    AdminStepController_create: (
      params: Params$AdminStepController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminStepController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/steps`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Delete a step
     * operationId: AdminStepController_delete
     * Request URI: /api/admin/steps/{id}
     */
    AdminStepController_delete: (
      params: Params$AdminStepController_delete,
      option?: RequestOption
    ): Promise<void> => {
      const url = _baseUrl + `/api/admin/steps/${params.parameter.id}`;
      const headers = {};
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a step
     * operationId: AdminStepController_update
     * Request URI: /api/admin/steps/{id}
     */
    AdminStepController_update: (
      params: Params$AdminStepController_update,
      option?: RequestOption
    ): Promise<
      Response$AdminStepController_update$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/steps/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Retrieve a list of payslip documents
     * operationId: AdminPayslipDocumentController_findAll
     * Request URI: /api/admin/payslip_documents
     */
    AdminPayslipDocumentController_findAll: (
      params: Params$AdminPayslipDocumentController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminPayslipDocumentController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/payslip_documents`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      const queryParameters: QueryParameters = {
        page: { value: params.parameter.page, explode: false },
        perPage: { value: params.parameter.perPage, explode: false },
        term: { value: params.parameter.term, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Create a payslip document
     * operationId: AdminPayslipDocumentController_create
     * Request URI: /api/admin/payslip_documents
     */
    AdminPayslipDocumentController_create: (
      params: Params$AdminPayslipDocumentController_create,
      option?: RequestOption
    ): Promise<void> => {
      const url = _baseUrl + `/api/admin/payslip_documents`;
      const headers = {
        'Content-Type': 'multipart/form-data',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a payslip document by its id
     * operationId: AdminPayslipDocumentController_findOneById
     * Request URI: /api/admin/payslip_documents/{id}
     */
    AdminPayslipDocumentController_findOneById: (
      params: Params$AdminPayslipDocumentController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminPayslipDocumentController_findOneById$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/payslip_documents/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Remove a payslip document by id
     * operationId: AdminPayslipDocumentController_delete
     * Request URI: /api/admin/payslip_documents/{id}
     */
    AdminPayslipDocumentController_delete: (
      params: Params$AdminPayslipDocumentController_delete,
      option?: RequestOption
    ): Promise<
      Response$AdminPayslipDocumentController_delete$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/payslip_documents/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a payslip document by id
     * operationId: AdminPayslipDocumentController_updateOneById
     * Request URI: /api/admin/payslip_documents/{id}
     */
    AdminPayslipDocumentController_updateOneById: (
      params: Params$AdminPayslipDocumentController_updateOneById,
      option?: RequestOption
    ): Promise<void> => {
      const url =
        _baseUrl + `/api/admin/payslip_documents/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'multipart/form-data',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * List all one time billing invoices
     * operationId: AdminBillingDocumentController_findAllOneTimeInvoices
     * Request URI: /api/admin/billing_documents/one_time_invoices
     */
    AdminBillingDocumentController_findAllOneTimeInvoices: (
      params: Params$AdminBillingDocumentController_findAllOneTimeInvoices,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingDocumentController_findAllOneTimeInvoices$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/billing_documents/one_time_invoices`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Create a one time billing invoice
     * operationId: AdminBillingDocumentController_createOneTimeInvoice
     * Request URI: /api/admin/billing_documents/one_time_invoices
     */
    AdminBillingDocumentController_createOneTimeInvoice: (
      params: Params$AdminBillingDocumentController_createOneTimeInvoice,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingDocumentController_createOneTimeInvoice$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/billing_documents/one_time_invoices`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Create a credit note
     * operationId: AdminBillingDocumentController_createCreditNote
     * Request URI: /api/admin/billing_documents/credit_note
     */
    AdminBillingDocumentController_createCreditNote: (
      params: Params$AdminBillingDocumentController_createCreditNote,
      option?: RequestOption
    ): Promise<void> => {
      const url = _baseUrl + `/api/admin/billing_documents/credit_note`;
      const headers = {
        'Content-Type': 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Create a credit note using contract version 3
     * operationId: AdminBillingDocumentController_createCreditNoteV3
     * Request URI: /api/admin/billing_documents/v3/credit_note
     */
    AdminBillingDocumentController_createCreditNoteV3: (
      params: Params$AdminBillingDocumentController_createCreditNoteV3,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingDocumentController_createCreditNoteV3$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/billing_documents/v3/credit_note`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Describe the supported credit-note request contract
     * operationId: AdminBillingDocumentController_getCreditNoteCapabilities
     * Request URI: /api/admin/billing_documents/credit_note_capabilities
     */
    AdminBillingDocumentController_getCreditNoteCapabilities: (
      params: Params$AdminBillingDocumentController_getCreditNoteCapabilities,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingDocumentController_getCreditNoteCapabilities$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/billing_documents/credit_note_capabilities`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a billing document by its id
     * operationId: AdminBillingDocumentController_findOneById
     * Request URI: /api/admin/billing_documents/{id}
     */
    AdminBillingDocumentController_findOneById: (
      params: Params$AdminBillingDocumentController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingDocumentController_findOneById$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/billing_documents/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Remove a billing document by id
     * operationId: AdminBillingDocumentController_delete
     * Request URI: /api/admin/billing_documents/{id}
     */
    AdminBillingDocumentController_delete: (
      params: Params$AdminBillingDocumentController_delete,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingDocumentController_delete$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/billing_documents/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a billing document by id
     * operationId: AdminBillingDocumentController_updateOneById
     * Request URI: /api/admin/billing_documents/{id}
     */
    AdminBillingDocumentController_updateOneById: (
      params: Params$AdminBillingDocumentController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingDocumentController_updateOneById$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/billing_documents/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Create a billing document
     * operationId: AdminBillingDocumentController_create
     * Request URI: /api/admin/billing_documents
     */
    AdminBillingDocumentController_create: (
      params: Params$AdminBillingDocumentController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminBillingDocumentController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/billing_documents`;
      const headers = {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a currency exchange rate
     * Get a currency exchange rate
     * operationId: AdminCurrencyExchangeRateController_getRate
     * Request URI: /api/admin/currency_exchange_rates
     */
    AdminCurrencyExchangeRateController_getRate: (
      params: Params$AdminCurrencyExchangeRateController_getRate,
      option?: RequestOption
    ): Promise<
      Response$AdminCurrencyExchangeRateController_getRate$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/currency_exchange_rates`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        from: { value: params.parameter.from, explode: false },
        to: { value: params.parameter.to, explode: false },
        date: { value: params.parameter.date, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Get all persons
     * Get all persons
     * operationId: AdminPersonsController_findAll
     * Request URI: /api/admin/incorporation/persons
     */
    AdminPersonsController_findAll: (
      params: Params$AdminPersonsController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminPersonsController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/incorporation/persons`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Create a new person
     * Create a new person
     * operationId: AdminPersonsController_create
     * Request URI: /api/admin/incorporation/persons
     */
    AdminPersonsController_create: (
      params: Params$AdminPersonsController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminPersonsController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/incorporation/persons`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get a person
     * Get a person
     * operationId: AdminPersonsController_findOne
     * Request URI: /api/admin/incorporation/persons/{id}
     */
    AdminPersonsController_findOne: (
      params: Params$AdminPersonsController_findOne,
      option?: RequestOption
    ): Promise<
      Response$AdminPersonsController_findOne$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/incorporation/persons/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update a person
     * Update a person
     * operationId: AdminPersonsController_update
     * Request URI: /api/admin/incorporation/persons/{id}
     */
    AdminPersonsController_update: (
      params: Params$AdminPersonsController_update,
      option?: RequestOption
    ): Promise<
      Response$AdminPersonsController_update$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/incorporation/persons/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PUT',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * operationId: AdminPersonsController_remove
     * Request URI: /api/admin/incorporation/persons/{id}
     */
    AdminPersonsController_remove: (
      params: Params$AdminPersonsController_remove,
      option?: RequestOption
    ): Promise<void> => {
      const url =
        _baseUrl + `/api/admin/incorporation/persons/${params.parameter.id}`;
      const headers = {
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Assign a ubo number to a person
     * Assign a ubo number to a person
     * operationId: AdminPersonsController_assignUboNumber
     * Request URI: /api/admin/incorporation/persons/{id}/assign-ubo-number
     */
    AdminPersonsController_assignUboNumber: (
      params: Params$AdminPersonsController_assignUboNumber,
      option?: RequestOption
    ): Promise<void> => {
      const url =
        _baseUrl +
        `/api/admin/incorporation/persons/${params.parameter.id}/assign-ubo-number`;
      const headers = {
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Get a list of obligations
     * Get a list of obligations
     * operationId: AdminObligationController_findAll
     * Request URI: /api/admin/obligations
     */
    AdminObligationController_findAll: (
      params: Params$AdminObligationController_findAll,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationController_findAll$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/obligations`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Creates a new obligation entity
     * Creates a new obligation entity
     * operationId: AdminObligationController_create
     * Request URI: /api/admin/obligations
     */
    AdminObligationController_create: (
      params: Params$AdminObligationController_create,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationController_create$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/obligations`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get an obligation by its id
     * Get an obligation by its id
     * operationId: AdminObligationController_findOneById
     * Request URI: /api/admin/obligations/{id}
     */
    AdminObligationController_findOneById: (
      params: Params$AdminObligationController_findOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationController_findOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/obligations/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Delete an obligation by its ID
     * Delete an obligation by its ID
     * operationId: AdminObligationController_deleteOneById
     * Request URI: /api/admin/obligations/{id}
     */
    AdminObligationController_deleteOneById: (
      params: Params$AdminObligationController_deleteOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationController_deleteOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/obligations/${params.parameter.id}`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'DELETE',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Update an obligation by its ID
     * Update an obligation by its ID
     * operationId: AdminObligationController_updateOneById
     * Request URI: /api/admin/obligations/{id}
     */
    AdminObligationController_updateOneById: (
      params: Params$AdminObligationController_updateOneById,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationController_updateOneById$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/obligations/${params.parameter.id}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'PATCH',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Get obligation events by obligation id
     * Get obligation events by obligation id
     * operationId: AdminObligationController_findEventsById
     * Request URI: /api/admin/obligations/{id}/events
     */
    AdminObligationController_findEventsById: (
      params: Params$AdminObligationController_findEventsById,
      option?: RequestOption
    ): Promise<
      Response$AdminObligationController_findEventsById$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/obligations/${params.parameter.id}/events`;
      const headers = {
        Accept: 'application/json',
        companyId: params.parameter.companyId,
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Preview the two-tier company → members recipient tree for an audience (no side effects).
     * operationId: NewsletterController_getRecipients
     * Request URI: /api/admin/newsletter/recipients
     */
    NewsletterController_getRecipients: (
      params: Params$NewsletterController_getRecipients,
      option?: RequestOption
    ): Promise<
      Response$NewsletterController_getRecipients$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/newsletter/recipients`;
      const headers = {
        Accept: 'application/json',
      };
      const queryParameters: QueryParameters = {
        audience: { value: params.parameter.audience, explode: false },
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
          queryParameters: queryParameters,
        },
        option
      );
    },
    /**
     * Full-rewrite sync of the selected recipients to the Listmonk list.
     * operationId: NewsletterController_sync
     * Request URI: /api/admin/newsletter/sync
     */
    NewsletterController_sync: (
      params: Params$NewsletterController_sync,
      option?: RequestOption
    ): Promise<
      Response$NewsletterController_sync$Status$201['application/json']
    > => {
      const url = _baseUrl + `/api/admin/newsletter/sync`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'POST',
          url,
          headers,
          requestBody: params.requestBody,
        },
        option
      );
    },
    /**
     * Status + summary of a previously enqueued sync job.
     * operationId: NewsletterController_syncStatus
     * Request URI: /api/admin/newsletter/sync/{jobId}
     */
    NewsletterController_syncStatus: (
      params: Params$NewsletterController_syncStatus,
      option?: RequestOption
    ): Promise<
      Response$NewsletterController_syncStatus$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/newsletter/sync/${params.parameter.jobId}`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * List Listmonk campaigns (read-only) for the stats selector.
     * operationId: NewsletterController_getCampaigns
     * Request URI: /api/admin/newsletter/campaigns
     */
    NewsletterController_getCampaigns: (
      option?: RequestOption
    ): Promise<
      Response$NewsletterController_getCampaigns$Status$200['application/json']
    > => {
      const url = _baseUrl + `/api/admin/newsletter/campaigns`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
    /**
     * Combined stats for a campaign: Listmonk send count + Postmark engagement (§15).
     * operationId: NewsletterController_getStats
     * Request URI: /api/admin/newsletter/stats/{campaignId}
     */
    NewsletterController_getStats: (
      params: Params$NewsletterController_getStats,
      option?: RequestOption
    ): Promise<
      Response$NewsletterController_getStats$Status$200['application/json']
    > => {
      const url =
        _baseUrl + `/api/admin/newsletter/stats/${params.parameter.campaignId}`;
      const headers = {
        Accept: 'application/json',
      };
      return apiClient.request(
        {
          httpMethod: 'GET',
          url,
          headers,
        },
        option
      );
    },
  };
};
type ClientFunction<RequestOption> = typeof createClient<RequestOption>;
export type Client<RequestOption> = ReturnType<ClientFunction<RequestOption>>;
